export const statewise_cities ={
  "Andaman and Nicobar Islands": [
    "Diglipur",
    "Port Blair",
    "Rongat"
  ],
  "Andhra Pradesh": [
    "Achampet",
    "Achchampeta",
    "Addanki",
    "Adigoppula",
    "adoni",
    "agadallanka",
    "Aginiparru",
    "agiripalle",
    "Akanavaritota",
    "Akividu",
    "Aklvidu",
    "alamuru",
    "Alasandigutta",
    "allagadda",
    "Allur",
    "Alluru",
    "Alur",
    "Amalapuram",
    "Amaravati",
    "Amaravati",
    "Ammanabrolu",
    "amudalapalle",
    "Amudalavalasa",
    "Anakapalle",
    "Ananipalle",
    "Anantapalle",
    "Anantapur",
    "Anantarazupeta",
    "Anantasagaram",
    "Angalakuduru Malepalle",
    "Angallu",
    "Ankireddikuntapalem",
    "Anndevarapeta",
    "Antarvedi",
    "Antarvedipalem",
    "Apparaopeta",
    "arambakkam",
    "Arugollu",
    "Asakapalle",
    "Asudapuram",
    "Atchampeta",
    "Atlapadu",
    "atmakur",
    "Atmakur",
    "atmakuru",
    "Attili",
    "Avanigadda",
    "Badvel",
    "Balighattam",
    "Bandamurlanka",
    "Banganapalle",
    "Bapatla",
    "Battulapalle",
    "Bayyanagudem",
    "Bayyavaram",
    "Belagal",
    "Bellamkonda",
    "Bendapudi",
    "Betamcherla",
    "Bhanumukkala",
    "Bhattiprolu",
    "Bhimadolu",
    "Bhimavaram",
    "Bhimunipatnam",
    "Bhogapuram",
    "Bikkavolu",
    "Billapadu",
    "Bobbili",
    "Bodagudipadu",
    "Boddikurapadu",
    "Bommagondanahalli",
    "Bondada",
    "Brahmanandapuram",
    "Buchireddipalem",
    "Buddayyakota",
    "Budili",
    "Bugganipalle",
    "Bukkapatnam",
    "Bukkarayasamudram",
    "Buttayagudem",
    "Chagalamarri",
    "Chagallu",
    "Chakicherla",
    "Challapalle",
    "Chamarru",
    "Chandragiri",
    "Chandralapadu",
    "Chandreru",
    "Channubanda",
    "Chapalamadugu",
    "Chebrolu",
    "Chebrolu",
    "Chennur",
    "Chennur",
    "Cherlagandlapalem",
    "Chicacole",
    "Chikkala",
    "Chilakalurupet",
    "Chilamatturu",
    "Chimakurti",
    "Chimalapadu",
    "Chinna Annaluru",
    "Chinna Ganjam",
    "Chinna Gollapalem",
    "Chinna Mushidivada",
    "Chinna Orampadu",
    "Chinnachauku",
    "Chinnamandem",
    "Chinnayagudem",
    "Chintakommadinne",
    "Chintakunta",
    "Chintalapudi",
    "Chintapalle",
    "Chintapalle",
    "Chipurupalle",
    "Chirala",
    "Chitrada",
    "Chittoor",
    "Chitvel",
    "Chodavaram",
    "Chodavaram",
    "Coringa",
    "Cuddapah",
    "Cumbum",
    "Dachepalle",
    "Damalcheruvu",
    "Dammennu",
    "Darsi",
    "Davuluru",
    "Denduluru",
    "Devanakonda",
    "Devarapalle",
    "Devarapalle",
    "Dharmajigudem",
    "Dharmavaram",
    "Dharmavaram",
    "Dharmavaram",
    "Dhone",
    "Dirusumarru",
    "Doddipatla",
    "Doranala",
    "Dowlaiswaram",
    "Draksharama",
    "Dubacherla",
    "Duggirala",
    "Durgi",
    "Duvva",
    "Duvvuru",
    "Duvvuru",
    "Edlapadu",
    "Elchuru",
    "Elesvaram",
    "Ellamanda",
    "Ellore",
    "Elurupadu",
    "Emmiganur",
    "Enamadala",
    "Enumulapalle",
    "Ernagudem",
    "Erraballa",
    "Erragondapalem",
    "Erraguntla",
    "Erraguntla",
    "Erraguntlakota",
    "Erramvaripalem",
    "Erravaram",
    "Galivedu",
    "Ganapavaram",
    "Ganapavaram",
    "Ganapavaram",
    "Ganapavaram",
    "Gandikunta",
    "Gandlapenta",
    "Gangammapeta",
    "Gangapatnam",
    "Ganguru",
    "Gannavaram",
    "Gatada",
    "Gaunivaripalle",
    "Gavinivaripalem",
    "Gazulapalle",
    "Ghattu",
    "Giddalur",
    "Gokavaram",
    "Gollalagunta",
    "Gollapudi",
    "Gonegandla",
    "Gooty",
    "Gopalapuram",
    "Gopavaram",
    "Gorantla",
    "Govindapalle",
    "Govindapuram",
    "Gudibanda",
    "Gudikallu",
    "Gudimulakhandrika",
    "Gudipallipadu",
    "Gudivada",
    "Gudivada",
    "Gudlavalleru",
    "Gudluru",
    "Gudur",
    "Guduru",
    "Gulyam",
    "Gundlapelle",
    "Gundrajukuppam",
    "Gundugolanu",
    "Gunjapalle",
    "Guntakal",
    "Guntakal Junction",
    "Guntapalli",
    "Guntupalle",
    "Guntur",
    "Gurlapeta",
    "Gurramkonda",
    "Guruvarajukuppam",
    "Guruzala",
    "Guttikonda",
    "Hamsavaram",
    "Hemavati",
    "Hindupur",
    "Hiramandalam",
    "Hirehaluhosahalli",
    "Hissaramuruvani",
    "Holalagondi",
    "Hosuru",
    "Ibrahimpatnam",
    "Ichchapuram",
    "idupugallu",
    "imani",
    "Inkollu",
    "Iskapalem",
    "Iskapalli",
    "Itamukkala",
    "Itikalapalle",
    "Ittikelakunta",
    "Jaggampeta",
    "Jaggayyapeta",
    "Jaggisettigudem",
    "Jaladurgam",
    "Jami",
    "Jammalamadugu",
    "Janakammapeta",
    "Janapadu",
    "Jandrapeta",
    "Jangalapalle",
    "Jangalapalli",
    "Jidigunta",
    "Jiyyammavalasa",
    "Jonnagiri",
    "Kachavaram",
    "Kadimetla",
    "Kadiri",
    "Kadiyadda",
    "Kadiyam",
    "Kaikalur",
    "Kaikaram",
    "Kakinada",
    "Kakkalapalle",
    "Kalakada",
    "Kalavapudi",
    "Kalicherla",
    "Kalikiri",
    "Kalipatnam",
    "Kalluru",
    "Kaluvaya",
    "Kalyandrug",
    "Kamalapuram",
    "Kamavarapukota",
    "Kambaduru",
    "Kambhaladinne",
    "Kambhampadu",
    "Kamepalle",
    "Kanasanapalle",
    "Kanchika",
    "Kandanati",
    "Kandukur",
    "Kandulapuram",
    "Kanekallu",
    "Kanigiri",
    "Kankanalapalle",
    "Kankipadu",
    "Kanteru",
    "Karanchedu",
    "Karapa",
    "Karedu",
    "Karempudi",
    "Karlapalem",
    "Karvetnagar",
    "Kasimkota",
    "Kathevaram",
    "Katravulapalle",
    "Kattamuru",
    "Katteragandla",
    "Kattipudi",
    "Kautalam",
    "Kavali",
    "Kaviti",
    "Kaza",
    "Kirikera",
    "Kirlampudi",
    "Kodavatipudi",
    "Kodigenahalli",
    "Kodumur",
    "Koduru",
    "Koilkuntla",
    "Kolakaluru",
    "Kolattur",
    "Kollipara",
    "Kolluru",
    "Kolumalapalle",
    "Komarolu",
    "Kommuru",
    "Konakondla",
    "Kondakindi Agraharam",
    "Kondakomarla",
    "Kondapalle",
    "Kondrukota",
    "Konduru",
    "Konidena",
    "Konkavaripalle",
    "Koppaka",
    "Kopparam",
    "Koppunur",
    "Kornepadu",
    "Korosavada",
    "Kosigi",
    "Kota",
    "Kotabommali",
    "Kothanuru",
    "Kottacheruvu",
    "Kottadindulu",
    "Kottakota",
    "Kottakota",
    "Kottapalem",
    "Kottapalem",
    "Kottapalle",
    "Kottapeta",
    "Kottapeta",
    "Kottavalasa",
    "Kotturu",
    "Kotturu",
    "Kott� Kalidindi",
    "Kovur",
    "Kovurupalli",
    "Kovvali",
    "Kovvur",
    "Krishnamsettipalle",
    "Krosuru",
    "Kubadupuram",
    "Kummarapurugupalem",
    "Kundurpi",
    "Kunkalagunta",
    "Kuppam",
    "Kurabalakota",
    "Kurichedu",
    "Kurnool",
    "Lakhanapuram",
    "Lakkavaram",
    "Lakkireddipalle",
    "Lakshmaneswaram",
    "Lepakshi",
    "Lingamparti",
    "Linganaboyinacherla",
    "Macherla",
    "Machilipatnam",
    "Madakalavaripalli",
    "Madakasira",
    "Madanapalle",
    "Maddikera",
    "Madhavaram",
    "Madugula",
    "Maduru",
    "Mailavaram",
    "Malaimarpuram",
    "Mamidalapadu",
    "Mandalapalle",
    "Mandapeta",
    "Mandasa",
    "Mangalagiri",
    "Mangalapur",
    "Mangasamudram",
    "Mansala",
    "Manubolu",
    "Marjampad",
    "Markapur",
    "Maruteru",
    "Maruturu",
    "Matsavaram",
    "Medapadu",
    "Medarametla",
    "Melavayi",
    "Miduturu",
    "Moda",
    "Mogalturru",
    "Molagavalli",
    "Morubagalu",
    "Muddada",
    "Muddanuru",
    "Mulakaledu",
    "Mulakaluru",
    "Mummidivaram",
    "Munagapaka",
    "Munnelli",
    "Muppalla",
    "Murapaka",
    "Murukondapadu",
    "Mutluru",
    "Muttukuru",
    "Mutukuru",
    "Mutyalapalle",
    "Nadendla",
    "Nadikude",
    "Nadimpalem",
    "Nagalapuram",
    "Nagambhotlapalem",
    "Nagari",
    "Nagasamudram",
    "Nagayalanka",
    "Nagireddipalli",
    "Nagulapadu",
    "Nalakadoddi",
    "Nallagunta",
    "Nallajerla",
    "Nallamada",
    "Nallamadu",
    "Namakadu",
    "Namburu",
    "Nandamuru",
    "Nandavaram",
    "Nandigama",
    "Nandikotkur",
    "Nandimandalam",
    "Nandyal",
    "Nandyalampeta",
    "Narapala",
    "Narasannapeta",
    "Narasapur",
    "Narasapuram",
    "Narasaraopet",
    "Narayanavanam",
    "Narendrapatnam",
    "Narsipatnam",
    "Nayudupet",
    "Nekarikallu",
    "Nellimarla",
    "Nellore",
    "Nidadavole",
    "Nidamaluru",
    "Nidamanuru",
    "Nizampatam",
    "Nulivedu",
    "Nunna",
    "Nutakki",
    "Nuzvid",
    "Obalapuram",
    "Ommangi",
    "Ongole",
    "Oppicherla",
    "Owk",
    "Padarti",
    "Padugupadu",
    "Pagidyala",
    "Pakala",
    "Pakala",
    "Palakollu",
    "Palasa",
    "Palkonda",
    "Palkur",
    "Pallipattu",
    "Palmaner",
    "Palukudoddi",
    "Pamarru",
    "Pamidi",
    "Pamuru",
    "Panasapadu",
    "Pandireddigudem",
    "Paniem",
    "Papampeta",
    "Paragaticherla",
    "Paravada",
    "Parigi",
    "Parimpudi",
    "Paruchuru",
    "Parvatipuram",
    "Pasivedalajimma",
    "Pata Ellamilli",
    "Pata Kalidindi",
    "Pata Putrela",
    "Patakakani",
    "Patapatnam",
    "Pattikonda",
    "Payakaraopeta",
    "Pedagadi",
    "Pedana",
    "Pedda Kotayalanka",
    "Pedda Nindrakolanu",
    "Pedda Penki",
    "Pedda Tumbalam",
    "Pedda Vegi",
    "Peddaboddepalle",
    "Peddakurapadu",
    "Peddannavaripalle",
    "Peddapalle",
    "Peddapuram",
    "Peddavadlapudi",
    "Penamaluru",
    "Pendekallu",
    "Pendurti",
    "Pentapadu Kasba",
    "Penuganchiprolu",
    "Penugolanu",
    "Penugonda",
    "Penukonda",
    "Penumur",
    "Perali",
    "Peravali",
    "Pernamitta",
    "Perupalem",
    "Peruru",
    "Phirangipuram",
    "Piduguralla",
    "Pileru",
    "Pillutla",
    "Pinneli",
    "Pithapuram",
    "Pittalavanipalem",
    "Podalakur",
    "Podili",
    "Polakala",
    "Polavaram",
    "Polukallu",
    "Pondaluru",
    "Ponduru",
    "Ponnada",
    "Ponnuru",
    "Poranki",
    "Porumamilla",
    "Potavaram",
    "Potukonda",
    "Potunuru",
    "Pragadavaram",
    "Prattipadu",
    "Prattipadu",
    "Proddatur",
    "Pudimadaka",
    "Pulakurti",
    "Pulimaddi",
    "Pulivendla",
    "Pulla",
    "Pullalacheruvu",
    "Pulluru",
    "Punganuru",
    "Punnavalli",
    "Putaparti",
    "Puttur",
    "Pyalakurti",
    "Pyapali",
    "Rajahmundry",
    "Rajanagaram",
    "Rajapudi",
    "Rajupalem",
    "Ramabhadrapuram",
    "Ramachandrapuram",
    "Ramachandrapuram",
    "Ramanayyapeta",
    "Ramasingavaram",
    "Rambilli",
    "Rangapuram",
    "Rangasamudram",
    "Rangasamudram",
    "Raparla",
    "Rapur",
    "Ravulapalem",
    "Ravutulapudi",
    "Rayachoti",
    "Rayadrug",
    "Rayapalle",
    "Rayavaram",
    "Razampeta",
    "Razole",
    "Reddigudem",
    "Reddipalle",
    "Relangi",
    "Rellivalasa",
    "Renigunta",
    "Rentachintala",
    "Repala",
    "Repalle",
    "Roddam",
    "Rolla",
    "Rompicherla",
    "Rompicherla",
    "Rudravaram",
    "Rupenaguntla",
    "Sabbavaram",
    "Samalkot",
    "Sanampudi",
    "Sangam",
    "Sankhavaram",
    "Sankhavaram",
    "Santamaguluru",
    "Sarpavaram",
    "Satravada",
    "Sattenapalle",
    "Satuluru",
    "Satyavedu",
    "Settivaripalle",
    "Sher Muhammadpuram",
    "Singarayakonda",
    "Sirvel",
    "Sitanagaram",
    "Somandepalle",
    "Somireddipalle",
    "Sompeta",
    "Srikurmam",
    "Sriramapuram",
    "Srisailain",
    "Srungavarapukota",
    "Sulleru",
    "Suluru",
    "Sundararaopeta",
    "Sunkarevu",
    "Suramala",
    "Swarna",
    "Tadepalle",
    "Tadepalle",
    "Tadepallegudem",
    "Tadigadapa",
    "Tadikalapudi",
    "Tadikonda",
    "Tadinada",
    "Tadpatri",
    "Talupula",
    "Tanakallu",
    "Tanguturu",
    "Tanuku",
    "Tekkali",
    "Telaprolu",
    "Tenali",
    "Teranikallu",
    "Tetagunta",
    "Tettu",
    "Timmapuram",
    "Tirumala",
    "Tirupati",
    "Tiruvur",
    "Tokatippa",
    "Tondangi",
    "Tripurantakam",
    "Trovagunta",
    "Tsallagundla",
    "Tsundupalle",
    "Tummalacheruvu",
    "Tummalapenta",
    "Tummalapenta",
    "Tummapala",
    "Tuni",
    "Udayagiri",
    "Ukkayapalle",
    "unagatla",
    "Undavalli",
    "Undi",
    "Undrajavaram",
    "Unguturu",
    "Uppada",
    "Uppalaguptam",
    "Uppalapadu",
    "Uppugunduru",
    "Uravakonda",
    "uttukkottai",
    "Vaddadi",
    "Valaparla",
    "Valasa",
    "Vallahbhapuram",
    "Vanipenta",
    "Vanukuru",
    "Varidhanam",
    "Vatluru",
    "Vavveru",
    "Vayalpad",
    "Vedurupavaluru",
    "Veldurti",
    "Velivennu",
    "Vellaturu",
    "Velpuru",
    "Velpuru",
    "Velugodu",
    "Vempalle",
    "Vempalle",
    "Vemuladivi",
    "Vemulapudi",
    "Vemuluru",
    "Vendram",
    "Venkatadripalem",
    "Venkatagiri",
    "Venkatagirikota",
    "Vetapalem",
    "Vidapanakallu",
    "Vijayavada",
    "Vikrutamala",
    "Vinjam",
    "Vinjamur",
    "Vinnamala",
    "Vinukonda",
    "Vipparla",
    "Viraghattam",
    "Virapalle",
    "Viravada",
    "Vishakhapatnam",
    "Vissannapeta",
    "Vizianagaram",
    "Vodurivandlagudem",
    "Vontimitta",
    "Vutukuru",
    "Vuyyuru",
    "Yadavolu",
    "Yadiki",
    "Yalamakuru",
    "Yalluru",
    "Yanam",
    "Yandrapalle",
    "Yekambarakuppam",
    "Yellayapalem",
    "Yenkuvarigudem",
    "Yerrapalem",
    "Zaladanki",
    "Zangareddigudem",
    "Zulakallu",
    "Zuvvaladinne"
  ],
  "Arunachal Pradesh": [
    "Itanagar",
    "Khagam",
    "Koloriang",
    "Pasighat",
    "Tezu",
    "Ziro"
  ],
  "Assam": [
    "Abhayapuri",
    "Amingaon",
    "Amtala",
    "Badarpur",
    "Barpathar",
    "Barpeta",
    "Bihpuriagaon",
    "Bijni",
    "Bilasipara",
    "Biswanath Chariali",
    "Bokakhat",
    "Bongaigaon",
    "Dagiapara",
    "Dergaon",
    "Dhalai",
    "Dhekiajuli",
    "Dhemaji",
    "Dhing",
    "Dhuburi",
    "Dibrugarh",
    "Digboi",
    "Diphu",
    "Dispur",
    "Dum Duma",
    "Gauripur",
    "Goalpara",
    "Gohpur",
    "Golaghat",
    "Goshaingaon",
    "Guwahati",
    "Hailakandi",
    "Hojai",
    "Howli",
    "Jamunamukh",
    "Jorhat",
    "Karaikandi",
    "Karimganj",
    "Kharupatia",
    "Kochugaon",
    "Kokiladanga",
    "Kokrajhar",
    "Lakhipur",
    "Lakhipur",
    "Lala",
    "Lumding",
    "Mangaldai",
    "Mankachar",
    "Margherita",
    "Mariani",
    "Masabdisa",
    "Moranha",
    "Nahorkatiya",
    "Nalbari",
    "Namrup",
    "North Guwahati",
    "North Lakhimpur",
    "Nowgong",
    "Rangapara",
    "Rangia",
    "Rupahi",
    "Sapatgram",
    "Sarpamari",
    "Sibsagar",
    "Silchar",
    "Singura",
    "Soalkuchi",
    "Sonaimukh",
    "Sonari",
    "Tezpur",
    "Tinkhang",
    "Tinsukia",
    "Udalguri",
    "Udarband"
  ],
  "Bihar": [
    "Abdullahnagar",
    "Abhia",
    "Abhwar",
    "Adalpur",
    "Afzala",
    "Agarpur",
    "Ahirauliya",
    "ahiro",
    "Ahmadabad",
    "Akbarpur",
    "Alamnagar",
    "alampur",
    "alampur Gonpura",
    "Alauli",
    "Aliganj",
    "Amaha",
    "Amari",
    "Amarpur",
    "Amauna",
    "Amba Icharua",
    "Amha",
    "Amiawar",
    "Amjhar",
    "amodei",
    "Amwa Majhar",
    "anandpur",
    "Andhana",
    "Andhra Tharhi",
    "Aphaur",
    "Arajpur",
    "Aranda",
    "Araria",
    "Areraj",
    "Arma",
    "Arniya",
    "Arrah",
    "Arwal",
    "Asahni",
    "Asarganj",
    "Asarhi",
    "Asthanwan",
    "Athar",
    "Auhar Sheikh",
    "Aurahi",
    "Aurahi",
    "Aurahi",
    "Aurahi",
    "Aurangabad",
    "Auria",
    "Auta",
    "azamnagar",
    "Azizpur Chande",
    "Babhanganwa",
    "Babhangaon",
    "Babhangawan",
    "Babhani Bholwa",
    "Babhantoli",
    "Babhniyawan",
    "Babhnoul",
    "Babura",
    "Bachhauta",
    "Bagaha",
    "Bagahi",
    "Bagaura",
    "Baghambarpur",
    "Baghant",
    "Baghauni",
    "Baghduma",
    "Baghmaria",
    "Baghra",
    "Bahadurganj",
    "Bahadurpur",
    "Baheri",
    "Baikatpur",
    "Bairagnia",
    "Bairi Chak",
    "Bairia",
    "Bairia",
    "Bairiya",
    "Bairo",
    "Baisa",
    "Bakarpur Ogairah",
    "Bakharia",
    "Bakhri",
    "Bakhtiyarpur",
    "Bakwa",
    "Balha",
    "Balhapur",
    "Baligaon",
    "Baltara",
    "Balua",
    "Balua Rampur",
    "Bamaiya Harlal",
    "Banbhag",
    "Bandwar",
    "Bangaon",
    "Bangaon",
    "Bangawan",
    "Bank",
    "Banki",
    "Banni",
    "Bansbari",
    "Banu Chhapra",
    "Bar Bigha",
    "Bara",
    "Bara Khurd",
    "Baragaon",
    "Barah",
    "Barahari",
    "Barahbatta",
    "Barahi",
    "Barahkurwa",
    "Barahpur",
    "Barahra",
    "Barai",
    "Baraidih",
    "Barajor",
    "Baraon",
    "Bararam",
    "Barari",
    "Barauli",
    "Barbana",
    "Bardiha Turki",
    "Baretha",
    "Bargaon",
    "Barhampur",
    "Barhampur",
    "Barhampur",
    "Barharia",
    "Barharwa Kalan",
    "Barhauna",
    "Barhauna",
    "Barhi",
    "Barhi",
    "Barhiya",
    "Bari",
    "Bariariya",
    "Bariariya Tola Rajpur",
    "Bariarpur",
    "Bariarpur",
    "Bariarpur Kandh",
    "Bariyarpur",
    "Barka Gaon",
    "Barka Parbatta",
    "Barki Ballia",
    "Barnaon",
    "Barni",
    "Baro",
    "Barsaun",
    "Baruari",
    "Barun",
    "Baruni",
    "Barwat Pasrain",
    "Basaha",
    "Basaithi",
    "Basantpur",
    "Basaon",
    "Basarh",
    "Basatpur",
    "Basbiti",
    "Basdeopur",
    "Basmanpur",
    "Basopatti",
    "Bataredh",
    "Bathnaha",
    "Baturbari",
    "Baulia",
    "Bazid Chak Kasturi",
    "Bazidpur",
    "Bazidpur Madhaul",
    "Begusarai",
    "Behat",
    "Bela",
    "Bela",
    "Bela",
    "Bela Simri",
    "Belao",
    "Belari",
    "Belauncha",
    "Belaur",
    "Beldaur",
    "Belhi",
    "Belo",
    "Belsand",
    "Belsandi Tara",
    "Belsara",
    "Belwa",
    "Belwara",
    "Benipati",
    "Besarh",
    "Bettiah",
    "Beur",
    "Bhabhua",
    "Bhachhi",
    "Bhachhi Asli",
    "Bhadas",
    "Bhado Khara",
    "Bhadsara",
    "Bhadwar",
    "Bhagalpur",
    "Bhagatpur",
    "Bhagwanpur Desua",
    "Bhagwatpur",
    "Bhainsahi",
    "Bhaisalotan",
    "Bhakua",
    "Bhalpatti",
    "Bhaluhar",
    "Bhandarso",
    "Bhangha",
    "Bhanghi",
    "Bhansia",
    "Bhargaon",
    "Bharhopur",
    "Bharokhara",
    "Bharra",
    "Bhasaula Danapur",
    "Bhataulia",
    "Bhatkhori",
    "Bhatranha",
    "Bhaur",
    "Bhauradah",
    "Bhawanandpur",
    "Bhawanipur",
    "Bhawanipur",
    "Bhawanipur",
    "Bhawanipur Rajdham",
    "Bheja",
    "Bhiraha",
    "Bhirua",
    "Bhit Bhagwanpur",
    "Bhojpur Jadid",
    "Bhojpur Kadim",
    "Bholsar",
    "Bhopatpur",
    "Bhui",
    "Bibhutpur",
    "Biddupur",
    "Bihar",
    "Bihariganj",
    "Bihat",
    "Bihpur",
    "Bihta",
    "Bijai",
    "Bikramganj",
    "Bikrampur Bande",
    "Bilauri",
    "Bimawan",
    "Bina",
    "Bind",
    "Birdaban",
    "Birhana",
    "Birnagar",
    "Birpur",
    "Birpur",
    "Birpur",
    "Birpur",
    "Birpur Barapatti Pindraun",
    "Bisaria",
    "Bisaul",
    "Bishunpur",
    "Bishunpur",
    "Bishunpur",
    "Bishunpur",
    "Bishunpur",
    "Bishunpur Hakimabad",
    "Bishunpur Sundar",
    "Bishunpura",
    "Bistaria",
    "Bithan",
    "Bithar",
    "Bithauli",
    "Bobil",
    "Bochaha",
    "Borna",
    "Borne",
    "Bucheya",
    "Buddh Gaya",
    "Budhma",
    "Bundehra",
    "Buram",
    "Burhia Dhanghatta",
    "Buxar",
    "Chahatpur",
    "Chailaha",
    "Chainpur",
    "Chainpura",
    "Chaita",
    "Chak Habib",
    "Chak Husaini",
    "Chak Pahar",
    "Chak That",
    "Chakai",
    "Chakand",
    "Chakia",
    "Chakla Waini",
    "Chakwai",
    "Champapur",
    "Chamtha",
    "Chanaur",
    "Chand Chaur",
    "Chandauli",
    "Chandhaus",
    "Chandi",
    "Chandpur",
    "Chandpura",
    "Chanp",
    "Chapra",
    "Charaut",
    "Charne",
    "Charuanwan",
    "Chatia",
    "Chatra Gobraura",
    "Chaugain",
    "Chauki",
    "Chauki Hasan Chauki Makhdum",
    "Chausa",
    "Chausa",
    "Chautham",
    "Cherakhera",
    "Cheran",
    "Chero",
    "Chewara",
    "Chhabila",
    "Chhapia",
    "Chhapra",
    "Chhapra Bahas",
    "Chhatapur",
    "Chikni",
    "Chikni",
    "Chilmil",
    "Chitauria",
    "Colgong",
    "Dagarua",
    "Dagmara",
    "Daharia",
    "Daharia",
    "Dahibhat Madhopur",
    "Dahua",
    "Dakhram",
    "Dalan",
    "Dalawarpur",
    "Dalippur",
    "Dalsingh Sarai",
    "Damu",
    "Dandkhora",
    "Danwan",
    "Daparkha",
    "Dara",
    "Darauli",
    "Darbhanga",
    "Darihat",
    "Darmaha",
    "Darpa",
    "Darsur",
    "Darwa",
    "Dasaut",
    "Dasraha Bhograjpur",
    "Datian",
    "Datiana",
    "Daudnagar",
    "Dayalpur",
    "Dayalpur Sapha",
    "Dehri",
    "Dehri",
    "Dehti",
    "Deo",
    "Deodha",
    "Deokali",
    "Deoria",
    "Desri",
    "Dewangarh",
    "Dhabauli",
    "Dhaka",
    "Dhakaich",
    "Dhamaun",
    "Dhamdaha",
    "Dhamsain",
    "Dhanauli",
    "Dhanaura",
    "Dhanga",
    "Dhangaraha",
    "Dhanupra",
    "Dharampur Bande",
    "Dharawat",
    "Dharhara",
    "Dharhwa",
    "Dharphari",
    "Dhauni",
    "Dhobauli",
    "Dholbaja",
    "Dhorgaon",
    "Dhumnagar",
    "Dhusar Tikapatti",
    "Dhutauli",
    "Dibraghani",
    "Dighaun",
    "Dighwa",
    "Dighwara",
    "Dihri",
    "Dilarpur",
    "Dinapore",
    "Dinara",
    "Dinmanpur",
    "Dip",
    "Dobhawan",
    "Dohta",
    "Doria Sonapur",
    "Dudhpura",
    "Dulhanganj",
    "Dumaria",
    "Dumra",
    "Dumra",
    "Dumraon",
    "Dumri",
    "Dumri",
    "Dumri",
    "Dumri",
    "Dumri",
    "Dumri",
    "Dumri",
    "Dumri",
    "Dumri",
    "Durgauti",
    "Ekamba",
    "Ekangar Sarai",
    "Ekchari",
    "Ekhari",
    "Ekma",
    "Ekma",
    "Ekwari",
    "Eraura",
    "Fateha",
    "Fatehabad",
    "Fatehpur",
    "Fatehpur",
    "Fatehpur",
    "Fatehpur",
    "Fatehpur Bala",
    "Fatehpur Shahbaz",
    "Fatwa",
    "Forbesganj",
    "Gadaul",
    "Gainrha",
    "Gajhara",
    "Gamail",
    "Gamharia",
    "Gamharia",
    "Ganeshpur",
    "Gangania",
    "Gangapur",
    "Gangapur",
    "Gangapur Athar",
    "Gangaur",
    "Gangaura Behra",
    "Garh Sisai",
    "Garhara",
    "Garhi",
    "Garhpura",
    "Garkha",
    "Gaundra",
    "Gaura",
    "Gaura",
    "Gaura",
    "Gaurdah",
    "Gaurihar Khaliqnagar",
    "Gaya",
    "Gayaspur",
    "Gethaura",
    "Ghanipur Bejha",
    "Ghataro Chaturbhuj",
    "Ghatawan",
    "Ghogardiha",
    "Ghorbanki",
    "Ghordaur",
    "Ghosai",
    "Ghosrawan",
    "Ghoswari",
    "Ghusiya",
    "Gidha",
    "Goasi",
    "Gobardhanpur Kanap",
    "Gobindpur",
    "Goh",
    "Gohi Bishunpur",
    "Gohuma Bairia",
    "Gokhulapur",
    "Golakpur",
    "Gonghaur",
    "Gopalganj",
    "Gopalpur",
    "Gorha",
    "Goriar",
    "Gosaingaon",
    "Gothini",
    "Guabari",
    "Gulam",
    "Gulni",
    "Gunri",
    "Guria",
    "Gurmaila",
    "Gurmia",
    "Gurwalia Biswas",
    "Hajipur",
    "Hakka",
    "Hansa",
    "Haraiya",
    "Hardas Bigha",
    "Hardi",
    "Hardia",
    "Hardia",
    "Hardiya",
    "Hardiya",
    "Harewa",
    "Hargawan",
    "Harihans",
    "Haripur",
    "Harlakhi",
    "Harnaut",
    "Harpur",
    "Harpur",
    "Harpur Bhindi",
    "Harpur Bochaha",
    "Harri",
    "Harsinghpur",
    "Hasanpur",
    "Hasanpur",
    "Hasanpur Juned",
    "Hasanpura",
    "Hata",
    "Hathapur",
    "Hathaura",
    "Hathauri",
    "Hathiakan",
    "Hathiaundha",
    "Hathidah Buzurg",
    "Hathwan",
    "Havi Bhauar",
    "Hazrat Shiura",
    "Hetanpur",
    "Hilsa",
    "Hirni",
    "Hisua",
    "Huseni",
    "Husepur",
    "Hussepur",
    "Ijra",
    "Ikhlaspur",
    "Isapur",
    "Islampur",
    "Ismailpur",
    "Israin Kalan",
    "Isua",
    "Itahri",
    "Itarhi",
    "Jadia",
    "Jadopur Shukul",
    "Jadupatti",
    "Jagannathpur",
    "Jagatpur",
    "Jagdishpur",
    "Jagdispur",
    "Jagta",
    "Jahangirpur Salkhani",
    "Jaipur Chuhar",
    "Jaisinghpur",
    "Jaitpur",
    "Jalalpur",
    "Jale",
    "Jalkaura",
    "Jalpura",
    "Jamalpur",
    "Jamalpur",
    "Jamalpur",
    "Jamhor",
    "Jamhra",
    "Jamira",
    "Jamsaut",
    "Jamui",
    "Jamunia",
    "Jankinagar",
    "Janpur",
    "Jasauli",
    "Jasauli Patti",
    "Jawkatia",
    "Jaynagar",
    "Jethuli",
    "Jhagarua",
    "Jhakhra",
    "Jhandapur",
    "Jhanjharpur",
    "Jharka",
    "Jhaua",
    "Jhaua",
    "Jhitkahiya",
    "Jhundo",
    "Jianganj",
    "Jirwa",
    "Jitpur",
    "Jitwarpur Chauth",
    "Jitwarpur Kumhra",
    "Jitwarpur Nizamat",
    "Jiwachhpur",
    "Jogaili",
    "Jogbani",
    "Jogiara",
    "Jurawanpur Karari",
    "Kabira",
    "Kabirpur",
    "Kachnar",
    "Kadrabad",
    "Kadwa",
    "Kahla",
    "Kaith",
    "Kaithahi",
    "Kaithinia",
    "Kaithwar",
    "Kajha",
    "Kajhi Hridenagar",
    "Kajur",
    "Kakan",
    "Kako",
    "Kakraul",
    "Kala Diara",
    "Kaler",
    "Kaleyanpur",
    "Kalikapur",
    "Kalyanpur",
    "Kalyanpur Bamaiya",
    "Kamrawan",
    "Kamtaul",
    "Kanchanpur",
    "Kanchanpur",
    "Kanhai",
    "Kanhaipur",
    "Kanhauli",
    "Kanhauli Manohar",
    "Kanp",
    "Kantai",
    "Kapasiawan",
    "Karahia",
    "Karariya",
    "Karath",
    "Karaund",
    "Kargahia Purab",
    "Karghar",
    "Karian",
    "Karmauli",
    "Karmegh",
    "Karor",
    "Karpi",
    "Karsaut",
    "Kasap",
    "Kasba",
    "Kasba",
    "Kasba Maker",
    "Kataha",
    "Katahra",
    "Katakos",
    "Katalpur",
    "Katarmala",
    "Katihar",
    "Katridih",
    "Katuria",
    "Kaua Kol",
    "Kaunra",
    "Kaurihar",
    "Kauriya",
    "Keal",
    "Kenar",
    "Keora",
    "Keota",
    "Kerai",
    "Kerap",
    "Kesariya",
    "Kesath",
    "Kewatgawan",
    "Khagaria",
    "Khagaul",
    "Khagaur",
    "Khagra",
    "Khair Khan",
    "Khaira",
    "Khaira",
    "Khaira Tola",
    "Khajuri",
    "Khajuri",
    "Khajuri",
    "Khandaich",
    "Khangaon",
    "Khanjahanpur",
    "Khanpur",
    "Khanpur Khairanti",
    "Khapdeh",
    "Kharagbani",
    "Kharagpur",
    "Kharahara",
    "Kharik",
    "Kharika",
    "Khaspur",
    "Khawaspur",
    "Khem Karan Saray",
    "Khirhar",
    "Khiria",
    "Khiriawan",
    "Khokha",
    "Khoragachhi",
    "Khundawandpur",
    "Khunti Dhanaili",
    "Khuran Milik",
    "Khusropur",
    "Khutaha",
    "Khutauna",
    "Khutha Baijnath",
    "Kingri",
    "Kiratpur Rajaram",
    "Kishanganj",
    "Kishanpur Ratwara",
    "Kishundaspur",
    "Kishunpur",
    "Kishunpur",
    "Kita Chauhattar",
    "Koath",
    "Koch",
    "Kochas",
    "Kochgawan",
    "Koelwar",
    "Koila",
    "Koila Belwa",
    "Koila Dewa",
    "Koilakh",
    "Koili Simra",
    "Koini",
    "Koiri Bigha",
    "Kolwara",
    "Konand",
    "Kopa",
    "Korahia",
    "Koriapatti",
    "Koskapur",
    "Koskapur",
    "Kothia",
    "Kotia",
    "Kotwapatti Rampur",
    "Kuchai Kot",
    "Kudra",
    "Kujri",
    "Kukraun",
    "Kukraun",
    "Kulharia",
    "Kumar Khad",
    "Kumari",
    "Kumaripur",
    "Kumharsan",
    "Kundal",
    "Kurhani",
    "Kursaha",
    "Kurwa Mathia",
    "Kusaha",
    "Kusmaul",
    "Kusumha",
    "Labhgaon",
    "Lachhmipur",
    "Lagunia Raghukanth",
    "Lagunia Surajkanth",
    "Laheji",
    "Lakhaura",
    "Lakhminia",
    "Lakhna",
    "Lakhna",
    "Lakhnaur",
    "Lakho",
    "Lakri",
    "Lalganj",
    "Lalganj",
    "Lalmunia Munhara",
    "Lalsaraia",
    "Latauna",
    "Lathasepura",
    "Laualagaon",
    "Laukaha",
    "Laukaha",
    "Laukaria",
    "Lauriya Nandangarh",
    "Leama",
    "Lehara",
    "Lodhwe",
    "Lohiyar Ujain",
    "Lohna",
    "Lolokhur",
    "Luathaha",
    "Luckeesarai",
    "Lulhaul",
    "Madanpur",
    "Madanpur",
    "Madanpur",
    "Madhipura",
    "Madhopur",
    "Madhopur",
    "Madhopur",
    "Madhopur",
    "Madhopur Hazari",
    "Madhuban",
    "Madhuban",
    "Madhuban",
    "Madhuban Bediban",
    "Madhubani",
    "Madhubani",
    "Madhubani",
    "Madhubani",
    "Madhura",
    "Madhura",
    "Madhurapur",
    "Madna",
    "Maghra",
    "Mahalgaon",
    "Mahamda",
    "Maharajgani",
    "Mahesh Khunt",
    "Maheshram",
    "Maheswa",
    "Mahinathpur",
    "Mahinawan",
    "Mahisanrh",
    "Mahisi",
    "Mahmuda",
    "Mahrail",
    "Mahraurh",
    "Mahtha",
    "Mahthi",
    "Mahuwa Singhrai",
    "Maida Babhangawan",
    "Mairwa",
    "Majarhat",
    "Majhariya",
    "Majhariya Sheikh",
    "Majhaul",
    "Majhaulia",
    "Majhua",
    "Majra",
    "Majurwa",
    "Makhar",
    "Makhdumpur",
    "Malar",
    "Maldah",
    "Malepur",
    "Malhipur",
    "Mali",
    "Mali",
    "Malinagar",
    "Malingaon",
    "Malmal",
    "Mamobihat",
    "Maner",
    "Mangalpur Gudaria",
    "Manganj",
    "Mangarwara",
    "Mangobandar",
    "Mangrauni",
    "Mangrawan",
    "Manihari",
    "Manikpur",
    "Manikpur",
    "Manikpur",
    "Manjha",
    "Manjhi",
    "Manpaur",
    "Manrar",
    "Mansapur",
    "Mansingha",
    "Mansinghpur Bijrauli",
    "Manullahpatti",
    "Maqsuda",
    "Maranchi",
    "Maranga",
    "Marar",
    "Marauatpur",
    "Marhaura",
    "Marui",
    "Marwa",
    "Masar",
    "Masaurhi Buzurg",
    "Masdi",
    "Masrakh",
    "Mataili Khemchand",
    "Matauna",
    "Math Lohiyar",
    "Mathila",
    "Mathurapur",
    "Mathurapur",
    "Mau Dhaneshpur",
    "Mauji",
    "Meghaul",
    "Meghauna",
    "Mehdauli",
    "Mehdipur",
    "Mehsari",
    "Mekra",
    "Mianpur Dubauli",
    "Mirdaul",
    "Mirganj",
    "Mirzanagar",
    "Mirzapur",
    "Mocharim",
    "Mohan Eghu",
    "Mohania",
    "Mohanpur",
    "Mohanpur",
    "Mohanpur Gaughata",
    "Mohiuddinnagar",
    "Mohiuddinnagar",
    "Mokameh",
    "Mokarrampur",
    "Mokri",
    "Monghyr",
    "Morauna",
    "Morsand",
    "Morwa",
    "Mothihari",
    "Motipur",
    "Muhammadganj",
    "Mukhtarpur Salkani",
    "Muradpur",
    "Murajpur",
    "Murliganj",
    "Musapur",
    "Musapur",
    "Muzaffarpur",
    "Nabinagar",
    "Nagar Nahusa",
    "Nagarpara",
    "Nagdah",
    "Naini",
    "Nainijor",
    "Nanan",
    "Nandnawan",
    "Nao Kothi",
    "Narahia",
    "Narhan",
    "Narhat",
    "Nari Bhadaun",
    "Nariar",
    "Naruar",
    "Nasriganj",
    "Nathpur",
    "Nauagarhi",
    "Naubatpur",
    "Naugachhia",
    "Nauhata",
    "Naula",
    "Nautan Dube",
    "Nawa Nagar Nizamat",
    "Nawada",
    "Nawada",
    "Nawada",
    "Nawada",
    "Nawada",
    "Nawada Gobindganj",
    "Nawalpur",
    "Nawanagar",
    "Nayanagar",
    "Neuri",
    "Ninga",
    "Nirakpurpali",
    "Nirmali",
    "Nirpur",
    "Nohsa",
    "Nokha",
    "Nonahi",
    "Nonea",
    "Noniya",
    "Obra",
    "Olhanpur",
    "Onda",
    "Op",
    "Pachahi",
    "Pachauth",
    "Pachmir",
    "Pachrukha",
    "Pachrukhi",
    "Paduma",
    "Paharpur",
    "Paharpur",
    "Pahsara",
    "Pai Bigha",
    "Paikpar",
    "Paina",
    "Painal",
    "Paithan Kawai",
    "Pakarya Harsidhi",
    "Pakra",
    "Pakri",
    "Pakribarawan",
    "Pali",
    "Pama",
    "Panapur",
    "Panapur Langa",
    "Panchi",
    "Pandaul",
    "Panhar",
    "Panr",
    "Panrepatti",
    "Papraur",
    "Pararia",
    "Pararia",
    "Parasbani",
    "Parauli",
    "Parbata",
    "Pareo",
    "Parihara",
    "Pariharpur",
    "Pariharpur",
    "Pariyari",
    "Parmanpur",
    "Parora",
    "Parsa",
    "Parsa",
    "Parsad",
    "Parsagarhi",
    "Parsahi Sirsia",
    "Partap Tanr",
    "Partapnagar",
    "Parwaha",
    "Pasaul",
    "Pasraha",
    "Pastpar",
    "Pataili",
    "Patalia",
    "Pathra",
    "Pathraha",
    "Pathrajolhania",
    "Patilar",
    "Patjirwa",
    "Patna",
    "Patori",
    "Patpara",
    "Patsanda",
    "Patut",
    "Paura Madan Singh",
    "Pelagor",
    "Phaphot",
    "Pharaha",
    "Pharkia",
    "Phulaut",
    "Phulgachhi",
    "Phulhara",
    "Phulmalik",
    "Phulparas",
    "Phulwar",
    "Phulwaria",
    "Phulwaria",
    "Pilich",
    "Pinjranwan",
    "Pipariya",
    "Pipra",
    "Pipra Dewas",
    "Pipra Latif",
    "Pipra Naurangia",
    "Piprahi",
    "Pipraun",
    "Pir Maker",
    "Pirnagar",
    "Piro",
    "Pirojgarh",
    "Piru",
    "Pithaura",
    "Pohadi",
    "Pohadi",
    "Pokhraira",
    "Pokhram",
    "Pothia",
    "Punarakh",
    "Pupri",
    "Puraini",
    "Puraini",
    "Puraini",
    "Puran Bigha",
    "Purnea",
    "Pursa",
    "Qadirganj",
    "Qutubpur",
    "Rafiganj",
    "Raghopur",
    "Raghopur",
    "Raghopur",
    "Raghunathpur",
    "Raghunathpur",
    "Raghunathpur",
    "Raghunathpur",
    "Raghunathpur",
    "Raghunathpur",
    "Rahiar Kunchi",
    "Rahika",
    "Rahimpur",
    "Rahta",
    "Rahui",
    "Raibari Mahuawa",
    "Raibhir",
    "Raipur",
    "Raipur Buzurg",
    "Raisari",
    "Raitar",
    "Raiyam",
    "Raja Pakar",
    "Rajauli",
    "Raje",
    "Rajepur",
    "Rajghat Garail",
    "Rajgir",
    "Rajhanpur",
    "Rajni",
    "Rajpur",
    "Rajpur Kalan",
    "Rakhwari",
    "Ramchandarpur",
    "Ramdiri",
    "Ramgarh",
    "Ramgarha",
    "Ramnagar",
    "Ramnagar",
    "Ramnagar Bankat",
    "Ramnagar Farsahi",
    "Rampatti",
    "Rampatti",
    "Rampur",
    "Rampur",
    "Rampur",
    "Rampur",
    "Rampur Jalalpur",
    "Rampur Khajuriya",
    "Rampur Kudarkatti",
    "Rampur Parhat",
    "Rampur Rajwa",
    "Rampur Shamchand",
    "Rampur Tilak",
    "Rampurwa",
    "Rangra",
    "Rani",
    "Rani Sagar",
    "Rani Shakarpura",
    "Ranko",
    "Ranti",
    "Rasauli",
    "Rasaunk",
    "Rasiari",
    "Raspur Patasia",
    "Rasulpur",
    "Rasulpur Dhuria",
    "Ratan",
    "Ratanpur",
    "Ratanpur",
    "Ratauli",
    "Raun",
    "Rautara",
    "Raxaul",
    "Reota",
    "Revelganj",
    "Rewahi",
    "Rewtith",
    "Rifadpur",
    "Riga",
    "Roh",
    "Rohar",
    "Rounia",
    "Rukhae",
    "Rupauli",
    "Rusera",
    "Rustampur",
    "Saadatpur Aguani",
    "Sabalpur",
    "Sabaur",
    "Sabnima",
    "Sadhoa",
    "Sadiqpur Maraul",
    "Sadpur",
    "Sagarpur",
    "Sagauli",
    "Saghar Sultanpur",
    "Sahar",
    "Saharbani",
    "Saharsa",
    "Sahasmal",
    "Sahibpur Kamal",
    "Sahidganj",
    "Sahit",
    "Saho",
    "Sahoria Subhai",
    "Sahpur",
    "Sahri",
    "Sahsaul",
    "Sahtah",
    "Sahuli",
    "Sahuria",
    "Saidabad",
    "Saidpur",
    "Saidpur Dabra",
    "Sakaddi",
    "Sakardih",
    "Sakhmohan",
    "Sakhua",
    "Sakri",
    "Saksohara",
    "Salehpur",
    "Salempur",
    "Salimpur",
    "Salkhua",
    "Samahuta",
    "Samai",
    "Samastipur",
    "Sambhu Chak",
    "Sandalpur",
    "Sangalbahita",
    "Sangi",
    "Sangram",
    "Sangrampur",
    "Sangrampur",
    "Sanha",
    "Sanjat",
    "Sanrh Majhgawan",
    "Sanrha",
    "Sansa",
    "Sanwas",
    "Sapahi",
    "Sarai Ranjan",
    "Saraiya",
    "Saraiya",
    "Sarangpur",
    "Sarari",
    "Sarauni",
    "Sarauni Kalan",
    "Saraunja",
    "Sarea Khas",
    "Saren",
    "Sarenja",
    "Sarmastpur",
    "Sarmera",
    "Sarotar",
    "Sarso",
    "Sasan",
    "Sasaram",
    "Satghara",
    "Sathmalpur",
    "Sattar",
    "Satwar",
    "Saurh",
    "Semra",
    "Semri",
    "Semri",
    "Senduria",
    "Seonar",
    "Sewa",
    "Shahar Telpa",
    "Shahpur",
    "Shahpur Baghauni",
    "Shahpur Chaumukhi",
    "Shahpur Undi",
    "Shahzadpur",
    "Shamgarh",
    "Shamsa",
    "Shamshernagar",
    "Shankar Saraiya",
    "Shankarpur",
    "Shankarpur Khawas",
    "Sheikhpura",
    "Sheohar",
    "Sher",
    "Sher Chakla",
    "Sherghati",
    "Sherpur",
    "Shitab Diara",
    "Sibkund",
    "Sidhap Kalan",
    "Sidhapa",
    "Sihaul",
    "Sihma",
    "Sikandarpur",
    "Sikandra",
    "Sikat",
    "Siktiahi",
    "Silao",
    "Simarbani",
    "Simaria",
    "Simaria",
    "Simarwara Durgapur",
    "Simrahi",
    "Simri",
    "Simri",
    "Simri",
    "Simri",
    "Simri Bakhriarpur",
    "Simria",
    "Singhara Buzurg",
    "Singhwara",
    "Singia",
    "Sinha",
    "Sirdala",
    "Siripur",
    "Siripur",
    "Sirkhandi Bhitha",
    "Sirmatpur",
    "Sirnia",
    "Sirsa",
    "Sirsia Hanumanganj",
    "Sisai",
    "Sisauna",
    "Sisia",
    "Siswa",
    "Siswa",
    "Siswar",
    "Sitalpur",
    "Sitalpur",
    "Sitamarhi",
    "Siur",
    "Siwan",
    "Sograha",
    "Sohta",
    "Sohtha",
    "Sokhodewara",
    "Solindabad",
    "Somnaha",
    "Sonapur",
    "Sonapur",
    "Sonbarsa",
    "Sondho Dullah",
    "Sondiha",
    "Sonhauli",
    "Sonpur",
    "Sontha",
    "Sonupur",
    "Sonwan",
    "Sothgaon",
    "Sowan",
    "Srinagar",
    "Srinagar",
    "Sripur",
    "Suganwan",
    "Sugaon",
    "Sugauna",
    "Sughrain",
    "Suhiya",
    "Sujapur",
    "Sukhasan",
    "Sukhasan",
    "Sukhsena",
    "Sukhsena",
    "Sultanganj",
    "Sultanpur",
    "Sumbha",
    "Sundarpur",
    "Supaul",
    "Supaul",
    "Surajgarha",
    "Surajpura",
    "Sursand",
    "Sutihar",
    "Tabhka Khas",
    "Tadhwa Nandpur",
    "Tajpur",
    "Tamganj",
    "Taran",
    "Tarar",
    "Tarauna",
    "Tarawan",
    "Tarwara",
    "Taulaha",
    "Teghra",
    "Teghra English",
    "Tekari",
    "Telkap",
    "Telkathu",
    "Telmar",
    "Telpur",
    "Telua",
    "Telwa",
    "Telwa",
    "Tetari",
    "Teus",
    "Thakurainia",
    "Thatha",
    "Thathupur",
    "Thepaha Raja Ram",
    "Tilari",
    "Tilothu",
    "Tinkoni",
    "Tiri",
    "Titara",
    "Tola Khadda",
    "Tulshia",
    "Turhapatti",
    "Turkauliya",
    "Turki",
    "Turki",
    "Uchti",
    "Udaipur Bithwar",
    "Udawantnagar",
    "Ughara",
    "Ukhai Purbari Patti",
    "Ulao",
    "Umga",
    "Urlaha",
    "Usmanpur",
    "Waris Aliganj"
  ],
  "Chandigarh": [
    "Chandigarh",
    "Kararan"
  ],
  "Chhattisgarh": [
    "Ambikapur",
    "Bhilai",
    "Bhilai Karanja",
    "Bilaspur",
    "Chanwari",
    "Dalli Rajhara",
    "Dantewara",
    "Dhamtari",
    "Drug",
    "Jagdalpur",
    "Janjgir",
    "Kharod",
    "Kolga",
    "Korba",
    "Mahasamund",
    "Mohda",
    "Mungeli",
    "Nava Raipur",
    "Pilkha",
    "Raigarh",
    "Raipur",
    "Rajim",
    "Ratanpur",
    "Sakti",
    "Sukma"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Daman",
    "Diu",
    "Silvassa"
  ],
  "Delhi": [
    "Bakhtawarpur",
    "Bawana",
    "Bhalswa Jahangirpur",
    "Chhatarpur",
    "Dalupura",
    "Delhi",
    "Delhi Cantonment",
    "Madangir",
    "Mundka",
    "Najafgarh",
    "Nangloi Jat",
    "Narela",
    "New Delhi",
    "Qatlupur",
    "Sultanpur Mazra"
  ],
  "Goa": [
    "Anjuna",
    "Bandora",
    "Benaulim",
    "Borim",
    "Colangute",
    "Corgao",
    "Cortalim",
    "Cuncolim",
    "Curchorem",
    "Curti",
    "Curtorim",
    "Davorlim",
    "Dicholi",
    "Kankon",
    "Madgaon",
    "Mahem",
    "Marmagao",
    "Navelim",
    "Nuvem",
    "Panaji",
    "Ponda",
    "Poninguinim",
    "Raia",
    "Sancoale",
    "Sanquelim",
    "Siroda",
    "Solim",
    "Surla",
    "Tivim",
    "Usgao",
    "Valpoy",
    "Vasco Da Gama",
    "Velim"
  ],
  "Gujarat": [
    "Adalaj",
    "Adesar",
    "Ahmedabad",
    "Ahwa",
    "Amreli",
    "anand",
    "Anghad",
    "Avidha",
    "Babra",
    "Bagasra",
    "Balagam",
    "Bardoli",
    "Bareja",
    "Barjhar",
    "Barvala",
    "Bhachau",
    "Bhanvad",
    "Bharuch",
    "Bhavnagar",
    "Bhayala",
    "Bhiloda",
    "Bhuj",
    "Bilimora",
    "Botad",
    "Chaklasi",
    "Chalala",
    "Chanasma",
    "Chandrawada",
    "Chhota Udepur",
    "Chorwad",
    "Dabhoi",
    "Dahegam",
    "Dakor",
    "Delvada",
    "Devgadh Bariya",
    "Dhandhuka",
    "Dhanera",
    "Dhansura",
    "Dharampur",
    "Dhari",
    "Dharmaj",
    "Dholka",
    "Dhoraji",
    "Dhrangadhra",
    "Dhrol",
    "Disa",
    "Dwarka",
    "Gadhada",
    "Gandevi",
    "Gandhidham",
    "Gariadhar",
    "Ghandinagar",
    "Ghogha",
    "Godhra",
    "Godhra",
    "Gondal",
    "Gothva",
    "Halol",
    "Halvad",
    "Hansot",
    "Harij",
    "Himatnagar",
    "Idar",
    "Jafarabad",
    "Jalalpur",
    "Jambughoda",
    "Jambusar",
    "Jamnagar",
    "Jasdan",
    "Jetpur",
    "Jodhpur",
    "Junagadh",
    "Kadi",
    "Kadod",
    "Kalavad",
    "Kalol",
    "Kalol",
    "Kamrej",
    "Kandla Port",
    "Kapadvanj",
    "Karakthal",
    "Karjan",
    "Kerwada",
    "Keshod",
    "Khambhaliya",
    "Khambhat",
    "Khawad",
    "Khed Brahma",
    "Kheda",
    "Kheralu",
    "Khergam",
    "Koba",
    "Kodinar",
    "Kosamba",
    "Koth",
    "Kukarmunda",
    "Kutiyana",
    "Ladol",
    "Langhnaj",
    "Lathi",
    "Limbdi",
    "Lunavada",
    "Mahemdavad",
    "Mahesana",
    "Mahudha",
    "Mahuva",
    "Mahuver",
    "Manavadar",
    "Mandvi",
    "Mandvi",
    "Mangrol",
    "Mansa",
    "Maroli",
    "Matar",
    "Matar",
    "Meghraj",
    "Modasa",
    "Morasar",
    "Morbi",
    "Moviya",
    "Muli",
    "Mundra",
    "Nadiad",
    "Nakhtarana",
    "Naliya",
    "Nandod",
    "Navsari",
    "Nawsari",
    "Od",
    "Okha",
    "Paddhari",
    "Padra",
    "Palanpur",
    "Palitana",
    "Panetha",
    "Pardi",
    "Parnera",
    "Patan",
    "Patri",
    "Petlad",
    "Porbandar",
    "Prantij",
    "Radhanpur",
    "Rajkot",
    "Rajula",
    "Ranavav",
    "Ranpur",
    "Rapar",
    "Rardhu",
    "Ratanpur",
    "Reha Mota",
    "Sachin",
    "Salaya",
    "Samadiala",
    "Samakhiali",
    "Sanand",
    "Sathamba",
    "Siddhapur",
    "Sihor",
    "Sikka",
    "Sinor",
    "Sojitra",
    "Songadh",
    "Sujnipur",
    "Surat",
    "Surendranagar",
    "Surpur",
    "Talaja",
    "Tankara",
    "Tarkeshwar",
    "Telnal",
    "Than",
    "Tharad",
    "Thol",
    "Tikar",
    "Ugamedi",
    "Ukal",
    "Umargam",
    "Umrat",
    "Umreth",
    "Una",
    "Unjha",
    "Upleta",
    "Vadasinor",
    "Vadnagar",
    "Vadodara",
    "Vaghodia",
    "Valabhipur",
    "Vallabh Vidyanagar",
    "Valsad",
    "Vanthli",
    "Vasa",
    "Vasad",
    "Veraval",
    "Vijapur",
    "Viramgam",
    "Visnagar",
    "Vyara",
    "Waghai",
    "Wankaner",
    "Wapi"
  ],
  "Haryana": [
    "Alewah",
    "Ambala",
    "Asthal Bohar",
    "Aurangabad",
    "Badshahpur",
    "Bapaura",
    "Bhattu Kolan",
    "Bhiwani",
    "Bilaspur",
    "Chang",
    "Charkhi Dadri",
    "Chhara",
    "Chotala",
    "Data",
    "Devsar",
    "Dhanauri",
    "Dhani Sukhan",
    "Dharampur",
    "Ellenabad",
    "Faridabad",
    "Fatehabad",
    "Fatehpur",
    "Gohna",
    "Gokulgarh",
    "Gondar",
    "Gorakhpur",
    "Gurugram",
    "Hansi",
    "Hisar",
    "Hodal",
    "Israna",
    "Jagadhri",
    "Jaimalpura",
    "Jind",
    "Kaithal",
    "Karnal",
    "Kathurah",
    "Kaul",
    "Kelangah",
    "Khanda",
    "Khandsa",
    "Kharak Kalan",
    "Kheri Naru",
    "Kundli",
    "Ladwa",
    "Madha",
    "Mahendragarh",
    "Majra",
    "Mirchpur",
    "Munak",
    "Mundahal Khurd",
    "Nangal Chaudhri",
    "Narnaul",
    "Narwana",
    "Nilothi",
    "Nisang",
    "Palwal",
    "Panchkula",
    "Panipat",
    "Pehowa",
    "Rania",
    "Ratia",
    "Rewari",
    "Rohtak",
    "Safidon",
    "Saha",
    "Samalkha",
    "Sirsa",
    "Sohna",
    "Sonipat",
    "Thanesar",
    "Tigrana",
    "Tohana",
    "ujhana",
    "Yamunanagar"
  ],
  "Himachal Pradesh": [
    "arda",
    "Arohi",
    "Bilaspur",
    "Chonthrhu",
    "Dargot",
    "Dharmsala",
    "Ilindu Kothi",
    "Kasumpti",
    "Kiratot",
    "Kotal",
    "Kulu",
    "Kun Puhal",
    "Mandi",
    "Nahan",
    "Nawagarh",
    "Nurpur",
    "Palampur",
    "Palangotu Adwar",
    "Pardwal",
    "Raita",
    "Shimla",
    "Solan",
    "Sundarnagar"
  ],
  "Jammu and Kashmir": [
    "Ajas",
    "Akhnur",
    "Awantipur",
    "Bandipura",
    "Baramula",
    "Barnoi",
    "Bhadarwah",
    "Bhulwal",
    "Bijbiara",
    "Bimun",
    "Birpur",
    "Bishnah",
    "Danau K�ndimarg",
    "Drabar",
    "Dras",
    "Gandarbal",
    "Gold",
    "Gulgam",
    "Guraahai",
    "Gurais",
    "Hajan",
    "Handwara",
    "Hanzviur",
    "Haripura",
    "Hokur Badasgom",
    "Islamabad",
    "Jammu",
    "Janglot",
    "Kaimuh",
    "Kalaruch",
    "Kangan",
    "Kargil",
    "Kathua",
    "Katra",
    "Khari",
    "Khattan",
    "Khaur",
    "Khiram",
    "Kishtwar",
    "Kotla",
    "Kulgam",
    "Leh",
    "Loran",
    "Magam",
    "Malangam",
    "Marah_m",
    "Noria",
    "Palhalan",
    "Pampur",
    "Panzgam",
    "Punch",
    "Qazigund",
    "Raipura",
    "Rajaori",
    "Ramnagar",
    "Ranbirsinghpura",
    "Salar",
    "Samba",
    "Sogam",
    "Sopur",
    "Srinagar",
    "Sumbal",
    "Sungal",
    "Tarazu",
    "Thatri",
    "Tsrar Sharif",
    "Udhampur",
    "Vernag"
  ],
  "Jharkhand": [
    "Achaljamu",
    "Angwali",
    "Arsali",
    "Bachra",
    "Baduriatola",
    "Balumath",
    "Banaso",
    "Bargaon",
    "Barharwa",
    "Barhi",
    "Barkagaon",
    "Barki Saria",
    "Barughutu",
    "Barwadih",
    "Beko",
    "Beldanga",
    "Bermo",
    "Bharno",
    "Bokaro",
    "Bokaro Steel City",
    "Borio",
    "Bundu",
    "Chakradharpur",
    "Chalkari",
    "Chandwa",
    "Chandwara",
    "Chas",
    "Chatra",
    "Chianki",
    "Chitarpur",
    "Churi",
    "Daltonganj",
    "Deoghar",
    "Dhanbad",
    "Dhansaria",
    "Dhanwar",
    "Domchanch",
    "Doranda",
    "Dugda",
    "Dumka",
    "Garhwa",
    "Gidi",
    "Godda",
    "Gomoh",
    "Gua",
    "Gumia",
    "Gumla",
    "Haidarnagar",
    "Hajipur",
    "Hazaribagh",
    "Hirpardangal",
    "Hosir",
    "Husainabad",
    "Ilami",
    "Itki Thakurgaon",
    "Jagannathpur",
    "Jainagar",
    "Jamshedpur",
    "Jamtara",
    "Jasidih",
    "Jori Kalan",
    "Jumri Tilaiya",
    "Kandra",
    "Kanke",
    "Karma",
    "Kedia",
    "Kenduadih",
    "Keshwari",
    "Khalari",
    "Kharki",
    "Kharsawan",
    "Khetko",
    "Khijri",
    "Khunti",
    "Kodarma",
    "Koiridih",
    "Kuju",
    "Kulgo",
    "Lal Khatanga",
    "Landupdih",
    "Lapanga",
    "Latehar",
    "Lohardaga",
    "Loiyo",
    "Madhupur",
    "Mahagama",
    "Maharajpur",
    "Makhmalpur",
    "Makri",
    "Mandramo",
    "Mandu",
    "Manoharpur",
    "Manushmuria",
    "Marai Kalan",
    "Markacho",
    "Meral",
    "Meru",
    "Mesra",
    "Mushabani",
    "Muturkha",
    "Noamundi",
    "Nunihat",
    "Okhargara",
    "Pakaur",
    "Palkot",
    "Paratdiha",
    "Patratu",
    "Phusro",
    "Pihra",
    "Pokhuria",
    "Ranchi",
    "Raneswar",
    "Ratu",
    "Sahibganj",
    "Saraikela",
    "Saram",
    "Saunda",
    "Sewai",
    "Shahpur",
    "Sijua",
    "Siladon",
    "Simdega",
    "Sini",
    "Sisai",
    "Sodag",
    "Sukurhutu",
    "Taisar",
    "Tamar",
    "Tati",
    "Torpa",
    "Tundhul",
    "Udburu",
    "Ulatu",
    "Usmanpur"
  ],
  "Karnataka": [
    "Abbigeri",
    "Abbigeri",
    "adivala",
    "Afzalpur",
    "Agadi",
    "Ainapur",
    "Ajjampur",
    "Ajjipuram",
    "Akalapura",
    "Aland",
    "Alawandi",
    "Almel",
    "Alnavar",
    "Amarapuuram",
    "Ambalanur",
    "Amingarh",
    "Anantpur",
    "anavatti",
    "Anekal",
    "Ankalgi",
    "Ankli",
    "Ankola",
    "Annigeri",
    "Antargangi",
    "Arakere",
    "Arsikere",
    "atharga",
    "Athni",
    "Aurad",
    "Aurad Shahjahani",
    "Aymangala",
    "Badagabettu",
    "Badami",
    "Badanahatti",
    "Bagalkot",
    "Bagalvad",
    "Bagepalli",
    "Bagewadi",
    "Bail-Hongal",
    "Baindur",
    "Bajala",
    "Bajpe",
    "Balehonnur",
    "Banagi",
    "Banavar",
    "Bandalli",
    "Banhatti",
    "Bankapur",
    "Bannur",
    "Bantval",
    "Basapatna",
    "Basavakalyan",
    "Basavana Bagevadi",
    "Basrur",
    "Beladi",
    "Belagola",
    "Belakvadi",
    "Belgaum",
    "Belhatti",
    "Bellary",
    "Belma",
    "Beltangadi",
    "Belur",
    "Bendarhalli",
    "Bengaluru",
    "Besagarahalli",
    "Betigeri",
    "Betmangala",
    "Bhadravati",
    "Bhairapura",
    "Bhalki",
    "Bhanuvalli",
    "Bhatkal",
    "Bhoj",
    "Bidar",
    "Bijapur",
    "Bilgi",
    "Birur",
    "Bobleshwar",
    "Bommarbettu",
    "Borgaon",
    "Bowringpet",
    "Byadgi",
    "Byahatti",
    "Byatarayanpur",
    "Chadchan",
    "Chalgeri",
    "Challakere",
    "Chamrajnagar",
    "Channagiri",
    "Channapatna",
    "Channarayapatna",
    "Chik Ballapur",
    "Chik Banavar",
    "Chikmagalur",
    "Chiknayakanhalli",
    "Chikodi",
    "Chinchali",
    "Chincholi",
    "Chintalapalle",
    "Chintamani",
    "Chitaldrug",
    "Chitapur",
    "Closepet",
    "Coondapoor",
    "Daddi",
    "Dambal",
    "Dandeli",
    "Dasarhalli",
    "Davangere",
    "Deodrug",
    "Desanagi",
    "Devanhalli",
    "Devgeri",
    "Devirammanahalli",
    "Dhanur Kalyanwadi",
    "Dharmastala",
    "Dod Ballapur",
    "Dodarasinakere",
    "Doddanahalli",
    "Dodvad",
    "Dommasandra",
    "Doranahalli",
    "Dundankop",
    "Eksambe",
    "Emmiganuru",
    "Fraserpet",
    "Gadag",
    "Gajendragarh",
    "Gajiginhalu",
    "Galatge",
    "Gangawati",
    "Gangoli",
    "Garag",
    "Ghat Borul",
    "Gokak",
    "Gokarn",
    "Gonikoppal",
    "Goribidnur",
    "Gubbi",
    "Gudgeri",
    "Gudibanda",
    "Gulbarga",
    "Guledagudda",
    "Gundlup_t",
    "Gurgunta",
    "Gurmatkal",
    "Guttal",
    "Hagaranahalli",
    "Hagaribommanahalli",
    "Halavagalu",
    "Haldipur",
    "Hale Dyamavvanahalli",
    "Halgeri",
    "Halgur",
    "Halikner",
    "Haliyal",
    "Halsur",
    "Hanamsagar",
    "Hangal",
    "Hanur",
    "Harihar",
    "Harohalli",
    "Harohalli",
    "Harpanahalli",
    "Hassan",
    "Hatti",
    "Hatti Mattur",
    "Havanur",
    "Haveri",
    "Hebli",
    "Hebri",
    "Heggadadevankote",
    "Hejamadi",
    "Herohalli",
    "Hesarghatta",
    "Hindalgi",
    "Hipparga",
    "Hire Megalageri",
    "Hire Vadvatti",
    "Hirehadagalli",
    "Hirehalli",
    "Hirekerur",
    "Hiriyur",
    "Holalkere",
    "Holalu",
    "Hole Narsipur",
    "Hombal",
    "Homnabad",
    "Honavar",
    "Honganur",
    "Honnali",
    "Horti",
    "Hosahalli",
    "Hosahalli",
    "Hosakote",
    "Hosdurga",
    "Hoskote",
    "Hospet",
    "Hosur",
    "Hosuru",
    "Hubli",
    "Hubli",
    "Hudli",
    "Hukeri",
    "Huliyar",
    "Hulkoti",
    "Hullahalli",
    "Hunasagi",
    "Hunasamaranhalli",
    "Hungund",
    "Hunsur",
    "Huvin Hippargi",
    "Ilkal",
    "Indi",
    "Itiki",
    "Jagalur",
    "Jalhalli",
    "Jalihalli",
    "Jawalgeri",
    "Jevargi",
    "Jigani",
    "K_tekara",
    "K_teshwar",
    "Kabbur",
    "Kadakola",
    "Kadoli",
    "Kadur",
    "Kaglipur",
    "Kagvad",
    "Kakhandiki",
    "Kaladgi",
    "Kalakeri",
    "Kalas",
    "Kalasa",
    "Kalghatgi",
    "Kalgi",
    "Kalkuni",
    "Kallur",
    "Kamalapuram",
    "Kamalnagar",
    "Kamatgi",
    "Kambla",
    "Kamdoli",
    "Kamlapur",
    "Kampli",
    "Kanabur",
    "Kanajanahalli",
    "Kanamadi",
    "Kannulu",
    "Kanur",
    "Kanyana",
    "Karadge",
    "Karajgi",
    "Karebilachi",
    "Karkala",
    "Karwar",
    "Katkol",
    "Kaujalgi",
    "Kavital",
    "Kawadgaon",
    "Kembhavi",
    "Kengri",
    "Keregodu",
    "Kerur",
    "Khanapur",
    "Kinhalu",
    "Kirangur",
    "Kittur",
    "Kodigenahalli",
    "Kolagallu",
    "Kolar",
    "Kollegal",
    "Kolnad",
    "Konaje",
    "Kondalahalli",
    "Konen Agrahar",
    "Kongnolli",
    "Konnur",
    "Konnur",
    "Koppal",
    "Koratagere",
    "Koratgi",
    "Kotturu",
    "Kowdalli",
    "Krishnarajasagara",
    "Krishnarajpet",
    "Krishnarajpur",
    "Kudachi",
    "Kudatini",
    "Kudligi",
    "Kuduru",
    "Kukkundur",
    "Kuknur",
    "Kumta",
    "Kundgol",
    "Kunigal",
    "Kurabur",
    "Kurdi",
    "Kurgunta",
    "Kurikuppi",
    "Kurtkoti",
    "Kurugodu",
    "Kushtagi",
    "Kusugal",
    "Lakkundi",
    "Lakshmeshwar",
    "Lingsugur",
    "Lokapur",
    "Maddagiri",
    "Madikeri",
    "Magadi",
    "Mahagaon",
    "Mahalingpur",
    "Mailapur",
    "Majali",
    "Malapannanagudi",
    "Malavalli",
    "Malebennur",
    "Malkhaid",
    "Mallapur",
    "Manchenahalli",
    "Mandya",
    "Mangala",
    "Mangalore",
    "Manglur",
    "Mangoli",
    "Manki",
    "Manne Ekeli",
    "Mannur",
    "Manoli",
    "Manvi",
    "Marathalli",
    "Mariyammanahalli",
    "Marne",
    "Martahalli",
    "Mashyal",
    "Maski",
    "Matala",
    "Mathigeri",
    "Mavalli",
    "Medleri",
    "Mishrikot",
    "Miyar",
    "Moka",
    "Molakalumuru",
    "Morab",
    "Motibennur",
    "Mudbidri",
    "Muddebihal",
    "Mudgal",
    "Mudgere",
    "Mudhol",
    "Mudhol",
    "Mugutkhan Hubli",
    "Mulbagal",
    "Mulgund",
    "Mulki",
    "Mumaradikop",
    "Mundargi",
    "Mundgod",
    "Munnuru",
    "Murgod",
    "Nadisal",
    "Nagamangala",
    "Nagathan",
    "Nagnur",
    "Nalatvad",
    "Nallur",
    "Nalwar",
    "Nanjangud",
    "Narasimharajapura",
    "Narayanpur",
    "Naregal",
    "Nargund",
    "Narona",
    "Navalgund",
    "Navalyal",
    "Nayakanhatti",
    "Nelamangala",
    "Nesarg",
    "Nidgundi",
    "Nipani",
    "Nirna",
    "Nitte",
    "Nulvi",
    "Nyamti",
    "Pachhapur",
    "Paduvari",
    "Parasurampur",
    "Pavugada",
    "Perdur",
    "Petmanhalli",
    "Piriyapatna",
    "Pudu",
    "Puttige",
    "Puttur",
    "Raichur",
    "Rajasur",
    "Ramdurg",
    "Rampura",
    "Ranibennur",
    "Ratnagiri",
    "Ratnahalli",
    "Rattihalli",
    "Raybag",
    "Robertsonpet",
    "Ron",
    "Sadalgi",
    "Sagar",
    "Sagar",
    "Sakleshpur",
    "Saligrama",
    "Salotgi",
    "Sambre",
    "Sampgaon",
    "Sandur",
    "Sanganakallu",
    "Sankeshwar",
    "Sante Bennur",
    "Sargur",
    "Sarjapur",
    "Satt_galam",
    "Satyamangala",
    "Saundatti",
    "Saunshi",
    "Savalgi",
    "Savanur",
    "Seram",
    "Shahpur",
    "Shedbal",
    "Shiddapur",
    "Shiggaon",
    "Shikarpur",
    "Shimoga",
    "Shirali",
    "Shirbadgi",
    "Shirguppi",
    "Shirhatti",
    "Shiruru",
    "Shirva",
    "Shorapur",
    "Shrirangapattana",
    "Siddapur",
    "Siddarampuram",
    "Sidlaghatta",
    "Sigli",
    "Sindgi",
    "Sindhnur",
    "Sira",
    "Siralkoppa",
    "Sirigeri",
    "Sirsi",
    "Siruguppa",
    "Sirur",
    "Sirvar",
    "Somvarpet",
    "Sorab",
    "Sosale",
    "Srinivaspur",
    "Sulahpet",
    "Sulibele",
    "Sulya",
    "Sunadkuppi",
    "Tadas",
    "Talakad",
    "Talikota",
    "Talya",
    "Tamba",
    "Tansandra",
    "Tarikere",
    "Tawargeri",
    "Tekkalakote",
    "Telsang",
    "Terdal",
    "Thogaduru",
    "Tikota",
    "Tilvalli",
    "Tiptur",
    "Tirthahalli",
    "Tirumakudal Narsipur",
    "Tonse East",
    "Tonse West",
    "Tuminkatti",
    "Tumkur",
    "Turbihal",
    "Turuvanur",
    "Turuvekere",
    "Tyamagondal",
    "Uchchangidurgam",
    "Udipi",
    "Udiyavara",
    "Ujre",
    "Ullal",
    "Uppur",
    "Vadigenhalli",
    "Virarajendrapet",
    "Vittal",
    "Wadgira",
    "Wadi",
    "Yadwad",
    "Yamkanmardi",
    "Yaragol",
    "Yargatti",
    "Yedtare",
    "Yelahanka",
    "Yelandur",
    "Yellapur",
    "Yelur",
    "Yermal"
  ],
  "Kerala": [
    "Achankovil",
    "Adukam",
    "aduru",
    "Aikaranad",
    "Aiyampuzha",
    "Aiyappan K_vil",
    "Akambadam",
    "Akkattettar",
    "Alandatte",
    "Alattur",
    "Alayaman",
    "Alengad",
    "Alleppey",
    "Alwaye",
    "Amala",
    "Anaikal",
    "Anantavur",
    "Andurkonam",
    "Angadikkal Tekkekara",
    "Angamali",
    "Anjarkandi",
    "Anjur",
    "Annakattumula",
    "Annakunnu",
    "Antur",
    "Arakkal",
    "Arakkapadi",
    "Aralam",
    "Aramangalam",
    "Aravankara",
    "Arttuvattala",
    "Arukutti",
    "Aruvapalam",
    "Assamannur",
    "Athiringal",
    "Attingal",
    "Avitanallur",
    "Ayanavelikulangara Tekku",
    "Ayanikkad",
    "Ayinikkad",
    "Ayirapuram",
    "Ayirurpara",
    "Azhikk_d",
    "Azhikkal",
    "Badiadka",
    "Balarampuram",
    "Balussheri",
    "Bangramanj_shvara",
    "Beypore",
    "Bharanikavu Tekku",
    "Calicut",
    "Cannanore",
    "Ch_manch_ri",
    "Chakkuvarakal",
    "Chalil",
    "Chalungalpadam",
    "Changamkari",
    "Changanacheri",
    "Chariyakulam",
    "Chatayamangalam",
    "Chattamangalam",
    "Chavakkad",
    "Chavara Gramam",
    "Chavassh_ri",
    "Chelora",
    "Chembra",
    "Chembrassh_ri",
    "Chemmanam",
    "Chemmaruthi",
    "Chengannur",
    "Chengara",
    "Chennamangalam",
    "Chennirkara",
    "Cherakara",
    "Cheranallur",
    "Cherukara",
    "Cherukolattur",
    "Cherukunnu",
    "Cherupazhasshi",
    "Cherupulassh_ri",
    "Cherutana Tekku",
    "Cheruvannur",
    "Cheruvaranam",
    "Chethakal",
    "Chetich_ri",
    "Chiramanangad",
    "Chiranellur",
    "Chithara",
    "Chittattukara",
    "Cholai",
    "Chunakara Vadakku",
    "Chundal",
    "Chundale",
    "Devikolam",
    "Edakkazhiyur",
    "Edakkunnam",
    "Edamon",
    "Edappalli",
    "Edasseri",
    "Edassh_ri",
    "Edattala",
    "Edattirutti",
    "Edavanakad",
    "Edayikunnam",
    "Elakadu",
    "Elamattur",
    "Elanad",
    "Elangunnapuzha",
    "Elanjivaliseri",
    "Elankur",
    "Elavalli",
    "Elukone",
    "Elur",
    "Engandiyur",
    "Enkakad",
    "Eramala",
    "Erattukulakkada",
    "Eravattur",
    "Erikolam",
    "Erumakkuzhi",
    "Eruvatti",
    "Etacheri",
    "Ezhamkulam",
    "Ezhipram",
    "Ganapathivattam",
    "Gothurutha",
    "Guruvayur",
    "Idukki",
    "Iramala",
    "Irikkur",
    "Irimbiliyam",
    "Iringal",
    "Irinjalakuda",
    "Irukanni",
    "Iruttarakonam",
    "Ittikara",
    "Ittiva",
    "K_danad",
    "K_r_th",
    "K_tt_ppadam",
    "K_ttaya",
    "Kadalur",
    "Kadamakudi",
    "Kadambanad",
    "Kadappuram",
    "Kadavur",
    "Kadikkad",
    "Kadinamkulam",
    "Kadungapuram",
    "Kaduturutti",
    "Kaippakanch_ri",
    "Kaipram",
    "Kakkat",
    "Kalamasseri",
    "Kalamula",
    "Kalanadu",
    "Kalanjur",
    "Kalayapuram",
    "Kalikavu",
    "Kallad",
    "Kallamalai",
    "Kallar",
    "Kallayi",
    "Kalleribhagam",
    "Kalliyassh_ri",
    "Kallur",
    "Kalpakathukonam",
    "Kalpatta",
    "Kanavaikuli",
    "Kandakkadava",
    "Kangazha",
    "Kanhangad",
    "Kank_l",
    "Kannadiparamba",
    "Kannamangalam",
    "Kannamangalam Tekku",
    "Kannapuram",
    "Kannavam",
    "Kanniparamba",
    "Kanniyambram",
    "Karadipara",
    "Karakurisshi",
    "Karavalur",
    "Karavaram",
    "Karikad",
    "Karimkunnum",
    "Karippira",
    "Kartikapalli",
    "Karttigappalli",
    "Karugamad",
    "Karukachal",
    "Karukurti",
    "Karumulaikkal",
    "Karunagapalli",
    "Karuvakulam",
    "Karuvambram",
    "Karuvellur",
    "Karvarakundu",
    "Kasaragod",
    "Kattakampala",
    "Kattanam",
    "Kattipparutti",
    "Kattiyeri",
    "Kavallemmavu",
    "Kayankulam",
    "Kayanna",
    "Kayaralam",
    "Kazhukambalam",
    "Kedavur",
    "Keevallur",
    "Kidamangalam",
    "Kidangazhi",
    "Kilattingal",
    "Killimangalam",
    "Kinalur",
    "Kizhake Chalakudi",
    "Kizhakk_tt",
    "Kizhakkanela",
    "Kizhakkemanad",
    "Kizhariyur",
    "Kizhattur",
    "Kizhur",
    "Kochi",
    "Kodayattur",
    "Kodikuthi",
    "Kodiy_ri",
    "Koduman",
    "Kodumba",
    "Kodungallur",
    "Kodusseri",
    "Koduvalli",
    "Koipadi",
    "Kolaccheri",
    "Kolattupuzha",
    "Kolavall�r",
    "Koliakkod",
    "Kollengode",
    "Kondazhi",
    "Kondur",
    "Kongarapalli",
    "Koni",
    "Kotanch_ri",
    "Kottangara",
    "Kottapadi",
    "Kottapuram",
    "Kottayam",
    "Kottukal",
    "Koturkolkara",
    "Kovur",
    "Kozhinjampara",
    "Krishnapuram",
    "Krishnapuram",
    "Kudali",
    "Kudayattur",
    "Kudlu",
    "Kumaramputtur",
    "Kumaranallur",
    "Kumarankari",
    "Kumbadaje",
    "Kumil",
    "Kunithala",
    "Kunjatturu",
    "Kunnamkulam",
    "Kunnatnad",
    "Kunnum_l",
    "Kuppadi",
    "Kuruvambalam",
    "Kutavettur",
    "Kutavur",
    "Kuttampala",
    "Kuttampuzha",
    "Kuttiy_ri",
    "Kuttuparamba",
    "Kuttur",
    "Kuttyadi",
    "Kuttyattur",
    "Kuzhippilli",
    "Lalam",
    "M_munda",
    "Madakkathara",
    "Madappalli",
    "Madavur",
    "Mah_",
    "Malaikkal",
    "Malappuram",
    "Mallapalli",
    "Mallappulasseri",
    "Manakayi",
    "Manambur",
    "Manampizha",
    "Manantheri",
    "Manatanna",
    "Mangalam",
    "Mangalapadi",
    "Manganam",
    "Maniamkulam",
    "Manikkal",
    "Manimala",
    "Maniyamturuttu",
    "Maniyur",
    "Manjeri",
    "Mankada",
    "Mankara",
    "Mannamangalam",
    "Mannamturuttu",
    "Mannanch_ri",
    "Mannara",
    "Mannarakkat",
    "Mannukara",
    "Mannur",
    "Mannur",
    "Maraiyur",
    "Marakkara",
    "Maranch_ri",
    "Marturu",
    "Maruthar_d",
    "Mathukumnel",
    "Mattanur",
    "Mattathur",
    "Mavelikara",
    "Mayilur",
    "Mayyanad",
    "Melila",
    "Melmuri",
    "Meltonakkal",
    "Meppayyur",
    "Minad",
    "Minja",
    "Mok_ri",
    "Mudakkal",
    "Mudakkiraye",
    "Mukkanur",
    "Mulakad",
    "Mulampilli",
    "Mulangodi",
    "Mulavana",
    "Mulavur",
    "Mullassh_ri",
    "Mullurkara",
    "Mundakkal",
    "Munnalam",
    "Munnar",
    "Munnark_d",
    "Munro Turuttu",
    "Muriyad",
    "Muthutala",
    "Muttam",
    "Muttat_di",
    "Muttattuteruvu",
    "Muvattupula",
    "Muzhakkunnu",
    "Naduvannur",
    "Naduvattam",
    "Nagarur",
    "Naikankudi",
    "Namminikara",
    "Nanattuparai",
    "Nanjakkad",
    "Nanminda",
    "Nannamukku",
    "Narala",
    "Narippatta",
    "Nediyanad",
    "Nedumana",
    "Nedumangad",
    "Nedumpura",
    "Nedumudi",
    "Neduvannur",
    "Neduvattur",
    "Nellaya",
    "Nellipoyil",
    "Nemmara",
    "Nenmini",
    "Neralakaje",
    "Neriyamangalam",
    "Nethirimangalam",
    "Neyyattinkara",
    "Nidiyanga",
    "Nilambur",
    "Niramaruthur",
    "Nirkunnam",
    "Ochanthururtha",
    "Odanavattam",
    "Omallur",
    "Orumanayur",
    "Oruvadalkotta",
    "Ottappalam",
    "Ottur",
    "Ozhur",
    "P_nagam",
    "P_ravur",
    "Padappakara",
    "Padinjarebagam",
    "Padinjaremuri",
    "Painkulam",
    "Paivalike",
    "Palakkuzhi",
    "Palamel",
    "Palayad",
    "Palghat",
    "Paliaturutu",
    "Pallarimangalam",
    "Pallikapuzha",
    "Palliman",
    "Pallippuram",
    "Pallippurattus_ri",
    "Pallipram",
    "Palod",
    "Pambadi",
    "Panamaram",
    "Panmana",
    "Panniperumthalai",
    "Panniyannur",
    "Pappinissh_ri",
    "Parakadavu",
    "Parali",
    "Parambatt Kavu",
    "Parambil",
    "Parappanangadi",
    "Parappukara",
    "Parappur",
    "Paravur Tekkumbhagam",
    "Paravurkambolam",
    "Pariyapuram",
    "Pariyaram",
    "Paruthur",
    "Pathanamthitta",
    "Pathiyanikunnu",
    "Pattambi",
    "Pattanakkad",
    "Pattanapuram",
    "Pattittara",
    "Pattiyurgramam",
    "Patuvilayi",
    "Pavannur",
    "Pavumba",
    "Payimattam",
    "Payipira",
    "Payyanadam",
    "Payyannur",
    "Payyanpalli",
    "Payyoli",
    "Pazhanji",
    "Pazhayannur",
    "Peragamanna",
    "Perampuzha",
    "Pering_ttukurusshi",
    "Peringalam",
    "Peringanad",
    "Peringom",
    "Peringuzha",
    "Perintalmanna",
    "Perladka",
    "Perumbalam",
    "Perumbalam",
    "Perumkulam",
    "Perunad",
    "Perungala",
    "Perunturuttu",
    "Peruvanthanam",
    "Pilachikare",
    "Pilappulli",
    "Pilik_du",
    "Pirakkad",
    "Piravanthur",
    "Pirmed",
    "Plach_ri",
    "Ponmala",
    "Ponmana",
    "Ponmundam",
    "Ponnani",
    "Poruvakara",
    "Pottanikad",
    "Pottassh_ri",
    "Pramatam",
    "Pudunagaram",
    "Puduparambubhagam",
    "Puduppalli Kunnam",
    "Puduva",
    "Pulimakkal",
    "Pulimathu",
    "Pulimel",
    "Puliyankunnu",
    "Pullanpallikonam",
    "Pullappalli",
    "Pulppatta",
    "Punalur",
    "Punnayur",
    "Punnila",
    "Puranattukara",
    "Purattur",
    "Puthupalli",
    "Puthuppariyaram",
    "Puttankulam",
    "Puttige",
    "Puttur",
    "Puvali",
    "Puyappalli",
    "Quilandi",
    "Quilon",
    "Ramamangalam",
    "Ramantali",
    "Rani",
    "Rar_tt",
    "Rayamangalam",
    "Sankaramangalam",
    "Sasthankotta",
    "Sh_ranur",
    "Shertallai",
    "Shutayil",
    "Sivapuram",
    "Tagazhi",
    "Talakkad",
    "Talayazham",
    "Talayolaparambu",
    "Talipparamba",
    "Talukkara",
    "Tamarakulam",
    "Tarur",
    "Tattamangalam",
    "Tazhakara",
    "Tazhava",
    "Tekk_kara",
    "Tekk_kara Kizhakku",
    "Tekkebhagam",
    "Tekkumbagam",
    "Tellicherry",
    "Tennala",
    "Thazhamel",
    "Thillang�ri",
    "Thiruvananthapuram",
    "Tholikuzhi",
    "Thondiamannu",
    "Timri",
    "Tirkadavur",
    "Tirkakara",
    "Tirkarur",
    "Tirur",
    "Tiruv_gapra",
    "Tiruvalla",
    "Tiruvambadi",
    "Tiruvarpu",
    "Todupulai",
    "Tonakkal",
    "Trichur",
    "Trikarpur North",
    "Trikkunnapuzha",
    "Trikodi",
    "Trikonavattam",
    "Triprang_ttur",
    "Tripunittura",
    "Trisshil_ri",
    "Tun_ri",
    "Turuttikkara",
    "Turuttiyad",
    "Tuvur",
    "Udumanthala",
    "Ulliyeri",
    "Ulliyil",
    "Ummannur",
    "Vadak_thara",
    "Vadakakarai",
    "Vadakkangara",
    "Vadakkum",
    "Vadakkumbagam",
    "Vaikam",
    "Vaisampakkal",
    "Vakkam",
    "Valambur",
    "Valatt",
    "Valavakattumula",
    "Valayam",
    "Valiyakumaramangalam",
    "Vallikunnam",
    "Valljkkod",
    "Valluvandad",
    "Vamanapuram",
    "Vammanal",
    "Vandamettu",
    "Vandikarai",
    "Vandiperiyar",
    "Vandithavalam",
    "Vanim_l",
    "Varandarapilli",
    "Varapatti",
    "Varisshiyakuni",
    "Varkkallai",
    "Vatakemuri",
    "Vavur",
    "Vayakkalattu",
    "Vayalar",
    "Vayanur",
    "Vazhani",
    "Vechur",
    "Veliyang_d",
    "Vellallur",
    "Vellanad",
    "Vellikulangara",
    "Vellithiruthi",
    "Velliy_d",
    "Vellur",
    "Venganellur",
    "Vengapalli",
    "Vengat",
    "Vengur",
    "Venkidanga",
    "Venmani",
    "Venmani Padinjara",
    "Vesala",
    "Vettam",
    "Vettikattiri",
    "Vettikkavala",
    "Vettur",
    "Vilakkudi",
    "Villanchirai",
    "Viyapuram",
    "Vorkadi",
    "Vuliyattara"
  ],
  "Lakshadweep": [
    "Kavaratti"
  ],
  "Madhya Pradesh": [
    "Agar",
    "Ajaigarh",
    "Akora",
    "Alampur",
    "Allahpur",
    "Amanganj",
    "Amarpatan",
    "Amarwara",
    "Amayan",
    "Ambara",
    "Amjhera",
    "Amla",
    "Anjad",
    "Antri",
    "Anuppur",
    "Aranya Kalan",
    "aron",
    "Ashoknagar",
    "Ashta",
    "Atner",
    "Babai",
    "Babai Kalan",
    "Badarwas",
    "Badnawar",
    "Bag",
    "Bagchini",
    "Bagli",
    "Bahadarpur",
    "Baihar",
    "Baikunthpur",
    "Baldeogarh",
    "Balvadi",
    "Bamaur",
    "Bamhni",
    "Bamora",
    "Banda",
    "Bankheri",
    "Bara Malehra",
    "Baragaon",
    "Bareh",
    "Barela",
    "Barghat",
    "Barhi",
    "Barigarh",
    "Barkuhi",
    "Barnagar",
    "Barod",
    "Baroda",
    "Baroni Khurd",
    "Barud",
    "Barwah",
    "Barwani",
    "Basoda",
    "Begamganj",
    "Beohari",
    "Berchha",
    "Betma",
    "Betul Bazar",
    "Bhainsdehi",
    "Bhanpura",
    "Bharweli",
    "Bhelsi",
    "Bhind",
    "Bhitarwar",
    "Bhopal",
    "Bhopalia",
    "Biaora",
    "Bijaipur",
    "Bijawar",
    "Bijeraghogarh",
    "Bilaua",
    "Bilehra",
    "Bilpura",
    "Birsinghpur",
    "Bistan",
    "Bora",
    "Budhni",
    "Burhanpur",
    "Burhar",
    "Chandera",
    "Chanderi",
    "Chandia",
    "Chandla",
    "Chhanera",
    "Chhapera",
    "Chhatarpur",
    "Chhindwara",
    "Chichli",
    "Chicholi",
    "Chikhli Kalan",
    "Chinaur",
    "Chorhat",
    "Dabhaura",
    "Daboh",
    "Dabra",
    "Dahi",
    "Damoh",
    "Damua",
    "Dasai",
    "Datia",
    "Datoda",
    "Deodora",
    "Deori Khas",
    "Depalpur",
    "Devendranagar",
    "Devmaudaldal",
    "Dewas",
    "Dhamnod",
    "Dhamnod",
    "Dhana",
    "Dhar",
    "Dharampuri",
    "Dhulkot",
    "Dighawani",
    "Dinara",
    "Dindori",
    "Dobni Para",
    "Dukli",
    "Ekalbehri",
    "Eklahra",
    "Etawa",
    "Fatipura",
    "Gadarwara",
    "Gairtganj",
    "Gandhwani",
    "Garhakota",
    "Garhi",
    "Garot",
    "Gauli Palasiya",
    "Gautampura",
    "Ghaura",
    "Ghogaon",
    "Ghoradongri",
    "Gohadi",
    "Gormi",
    "Govindgarh",
    "Guna",
    "Gurh",
    "Gwalior",
    "Hanumana",
    "Harda Khas",
    "Harduli",
    "Harrai",
    "Harsola",
    "Hatod",
    "Hatta",
    "Hatwans",
    "Hindoria",
    "Hoshangabad",
    "Iawar",
    "Ichhapur",
    "Iklod",
    "Indargarh",
    "Indore",
    "Isagarh",
    "Itarsi",
    "Jabalpur",
    "Jabera",
    "Jaisinghnagar",
    "Jaisinghnagar",
    "Jaitwar",
    "Jamai",
    "Jaora",
    "Jatara",
    "Jawad",
    "Jawasa",
    "Jhabua",
    "Jhonkar",
    "Jhundpura",
    "Jiran",
    "Jobat",
    "Jora",
    "Jora Khurd",
    "Junnardev",
    "Kailaras",
    "Kakarati",
    "Kampel",
    "Kaniwara",
    "Kannod",
    "Karahal",
    "Kareli",
    "Karera",
    "Kari",
    "Karnawad",
    "Karrapur",
    "Kasrawad",
    "Katangi",
    "Katangi",
    "Katri",
    "Keolari",
    "Kesli",
    "Khachrod",
    "Khajawa",
    "Khajuraho",
    "Khamaria",
    "Khandwa",
    "Khaniadhana",
    "Khargapur",
    "Khargone",
    "Kharsod B",
    "Khategaon",
    "Khathjari",
    "Khilchipur",
    "Khimlasa",
    "Khirkiyan",
    "Khujner",
    "Khurai",
    "Kirrayach",
    "Kod",
    "Kodriva",
    "Kolaras",
    "Kothi",
    "Kothri Kalan",
    "Kotma",
    "Kukdeshwar",
    "Kukshi",
    "Kumbhraj",
    "Kurawar",
    "Lahar",
    "Lakhnadon",
    "Lanji",
    "Lauri",
    "Leteri",
    "Lodhikheda",
    "Loharda",
    "Machalpur",
    "Maharajpur",
    "Maheshwar",
    "Mahugaon",
    "Maihar",
    "Maina",
    "Majhgawan",
    "Majhgawan",
    "Majholi",
    "Makronia",
    "Maksi",
    "Malhargarh",
    "Malthone",
    "Manasa",
    "Manawar",
    "Mandi Bamora",
    "Mandla",
    "Mandleshwar",
    "Mandsaur",
    "Manegaon",
    "Mangawan",
    "Manpur",
    "Mariyadau",
    "Mau",
    "Mauganj",
    "Mawai",
    "Mehidpur",
    "Mhow",
    "Mohana",
    "Mohdra",
    "Mohgaon",
    "Moman Barodiya",
    "Morena",
    "Multai",
    "Mundi",
    "Mungaoli",
    "Nagda",
    "Nagod",
    "Nahargarh",
    "Naigarhi",
    "Nainpur",
    "Namli",
    "Narayangarh",
    "Narsinghgarh",
    "Narwar",
    "Naryai ka Puri",
    "Nasrullahganj",
    "Naurhiya",
    "Nayagaon",
    "Nayagaon",
    "Nepanagar",
    "Nisarpur",
    "Nowgong",
    "Orchha",
    "Pachor",
    "Palda",
    "Palera",
    "Pali",
    "Palsud",
    "Panagar",
    "Pandhana",
    "Pandhurna",
    "Panna",
    "Pansemal",
    "Parasia",
    "Patan",
    "Patera",
    "Pathari",
    "Patharia",
    "Pawai",
    "Petlawad",
    "Phopnar Kalan",
    "Pichhor",
    "Pichor",
    "Pindra",
    "Pipalrawan",
    "Piparia",
    "Piploda",
    "Piprai",
    "Pirthipur",
    "Pithampur",
    "Polaia Kalan",
    "Porsa",
    "Prabhat Pattan",
    "Raghogarh",
    "Rahatgarh",
    "Raisen",
    "Rajakheri",
    "Rajaudha",
    "Rajgarh",
    "Rajgarh",
    "Rajnagar",
    "Rajod",
    "Rajpur",
    "Rajpur",
    "Rampur Kalan",
    "Rampura",
    "Ranapur",
    "Rangvasa",
    "Rangwasa",
    "Ranod",
    "Ratangarh",
    "Ratlam",
    "Raun",
    "Rehli",
    "Rehti",
    "Rewa",
    "Ringnod",
    "Sabalgarh",
    "Sailana",
    "Sainkhera",
    "Salaiya",
    "Sanchi",
    "Sannai",
    "Sanwer",
    "Sarangpur",
    "Sarni",
    "Satai",
    "Satna",
    "Satwas",
    "Saugor",
    "Sausar",
    "Segaon",
    "Sehore",
    "Semri",
    "Sendhwa",
    "Seondha",
    "Seoni",
    "Seoni Chhapara",
    "Seoni Malwa",
    "Shahdol",
    "Shahganj",
    "Shahgarh",
    "Shahpur",
    "Shahpur",
    "Shahpura",
    "Shahpura",
    "Shajapur",
    "Shamgarh",
    "Shampur",
    "Shamsabad",
    "Sheopur",
    "Shivpuri",
    "Shujalpur",
    "Sidhi",
    "Sihora",
    "Sihora",
    "Silvani",
    "Simaria",
    "Simrol",
    "Singhana",
    "Singoli",
    "Singrauliya",
    "Sirali",
    "Sirgora",
    "Sirmaur",
    "Sironj",
    "Sitamau",
    "Sobhapur",
    "Sohagpur",
    "Sonbari",
    "Sonkach",
    "Suhagi",
    "Sukand",
    "Sultanpur",
    "Sundarsi",
    "Susari",
    "Susner",
    "Suthalia",
    "Suwasra",
    "Tala",
    "Talen",
    "Tarana",
    "Tarichar Kalan",
    "Tekanpur",
    "Tendukheda",
    "Tendukheda",
    "Teonthar",
    "Thandla",
    "Thara",
    "Thikri",
    "Tigaon",
    "Tikamgarh",
    "Tikar",
    "Tillor Khurd",
    "Timurni",
    "Tirodi",
    "Tonk Khurd",
    "Ubaidullahganj",
    "Udaipura",
    "Ujjain",
    "Ukwa",
    "Umaria",
    "Umreth",
    "Umri",
    "Unchahra",
    "Unhel",
    "Vidisha",
    "Waraseoni",
    "Zirapur"
  ],
  "Maharashtra": [
    "Ahmadnagar",
    "Ahmadpur",
    "Akola",
    "Akot",
    "Alta",
    "Amalner",
    "Ambajogai",
    "Amravati",
    "Anjangaon",
    "Aurangabad",
    "Baramati",
    "Bhanas Hivre",
    "Bhayandar",
    "Bhilavadi",
    "Bhiwandi",
    "Bhusaval",
    "Bir",
    "Bramhapuri",
    "Chakur",
    "Chanda",
    "Chimthana",
    "Chinaval",
    "Chiplun",
    "Chopda",
    "Dahivel",
    "Dapoli",
    "Deolali",
    "Deoni Buzurg",
    "Deulgaon Mahi",
    "Devrukh",
    "Dhulia",
    "Dudhgaon",
    "Gandhali",
    "Ghargaon",
    "Ghoti Budrukh",
    "Gondia",
    "Halgar",
    "Ichalkaranji",
    "Jalalkhera",
    "Jalam",
    "Jalgaon",
    "Jalna",
    "Jamkhed",
    "Jula Buzarg",
    "Junnar",
    "Kalamboli",
    "Kalamner",
    "Kali",
    "Kalyan",
    "Kamthi",
    "Karad",
    "Karanja",
    "Karjat",
    "Karkamb",
    "Kashti",
    "Kedgaon",
    "Khandala",
    "Khed",
    "Khetia",
    "Khopoli",
    "Kodoli",
    "Kolhapur",
    "Kondhali",
    "Koregaon",
    "Kudal",
    "Kusumbe",
    "Ladkhed",
    "Loha",
    "Lohagaon",
    "Lonar",
    "Lonavale",
    "Mahabaleshwar",
    "Mahad",
    "Majalgaon",
    "Malanvadi",
    "Malegaon",
    "Malkapur",
    "Mangalvedha",
    "Manmad",
    "Manwat",
    "Masur",
    "Morsi",
    "Mukher",
    "Mumbai",
    "Murtajapur",
    "Murud",
    "Nagardevla Budrukh",
    "Nagpur",
    "Nalegaon",
    "Nanded",
    "Nandgaon",
    "Nandura Buzurg",
    "Nandurbar",
    "Naranda",
    "Narkher",
    "Nasik",
    "Navapur",
    "Nighoj",
    "Nilanga",
    "Nirala",
    "Nizampur",
    "Osmanabad",
    "Pachora",
    "Paithan",
    "Palghar",
    "Panchgani",
    "Pandharpur",
    "Panvel",
    "Parbhani",
    "Parner",
    "Partur",
    "Pathardi",
    "Pathri",
    "Pawni",
    "Pen",
    "Phaltan",
    "Piliv",
    "Pimpalgaon Raja",
    "Pimpri-Chinchwad",
    "Pirangut",
    "Pulgaon",
    "Pune",
    "Purna",
    "Rahata",
    "Rahuri",
    "Rajapur",
    "Ramewadi",
    "Rani Sawargaon",
    "Ratnagiri",
    "Raver",
    "Renapur",
    "Risod",
    "Sangamner",
    "Sangli",
    "Sangola",
    "Saoner",
    "Satana",
    "Satara",
    "Savda",
    "Selu",
    "Shegaon",
    "Shendurjana",
    "Shikrapur",
    "Shirdi",
    "Shirud",
    "Shrigonda",
    "Sillod",
    "Sinnar",
    "Sirur",
    "Sirur Tajband",
    "Solapur",
    "Soyagaon",
    "Srivardhan",
    "Talegaon Dabhade",
    "Talegaon Dhamdhere",
    "Talevad",
    "Taloda",
    "Tasgaon",
    "Thair",
    "Thane",
    "Tirora",
    "Tuljapur",
    "Turori",
    "Ulhasnagar",
    "Umarga",
    "Umarkhed",
    "Umred",
    "Unchagao",
    "Uran",
    "Urun-Islampur",
    "Vaijapur",
    "Vasai-Virar",
    "Vite",
    "Wadegaon",
    "Wai",
    "Walur",
    "Wangi",
    "Wani",
    "Wardha",
    "Warora",
    "Warud",
    "Washim",
    "Wasi",
    "Yavatmal",
    "Yeola"
  ],
  "Manipur": [
    "Bishenpur",
    "Chakpi Karong",
    "Hengken",
    "Imphal",
    "Kakching",
    "Kakching Khunou",
    "Mayang Imphal",
    "Meiti",
    "Moirang",
    "Thoubal",
    "Wabagai",
    "Yairipok"
  ],
  "Meghalaya": [
    "Cherrapunji",
    "Nongstoin",
    "Shillong",
    "Tura"
  ],
  "Mizoram": [
    "aizawl",
    "Chhimluang",
    "Keitumkawn",
    "Lunglei",
    "Pangzawl",
    "Saiha"
  ],
  "Nagaland": [
    "Dimapur",
    "Kohima",
    "Mokokchung",
    "Phek",
    "Tuensang",
    "Wokha",
    "Zunheboto"
  ],
  "Odisha": [
    "Anandpur",
    "Angul",
    "Aul",
    "Bada Barabil",
    "Baghmari",
    "Balangir",
    "Balasore",
    "Balugan",
    "Banapur",
    "Banki",
    "Bargarh",
    "Barhagarh",
    "Baripada",
    "Basudebpur",
    "Baud",
    "Belpara",
    "Betnoti",
    "Bhadrakh",
    "Bhawanipatna",
    "Bhuban",
    "Bhubaneshwar",
    "Bideipur",
    "Binka",
    "Birmitrapur",
    "Bishamagiri",
    "Boriguma",
    "Brahmapur",
    "Brajarajnagar",
    "Bramhabarada",
    "Buguda",
    "Burla",
    "Champua",
    "Chandili",
    "Charipara",
    "Chikitigarh",
    "Chudamani",
    "Cuttack",
    "Damonojodi",
    "Deogarh",
    "Dhamnagar",
    "Dhenkanal",
    "Fatehgarh",
    "Ganjam",
    "Gopalpur",
    "Gunupur",
    "Hirakud",
    "Itamati",
    "Jajpur",
    "Janhapara",
    "Jatani",
    "Jeypore",
    "Jharsugra",
    "Junagarh",
    "Kaintragarh",
    "Kalimala",
    "Kamakhyanagar",
    "Kantabanji",
    "Kantilo",
    "Karanjia",
    "Kendraparha",
    "Keonjhargarh",
    "Khallikot",
    "Khandpara",
    "Kharhial",
    "Khurda",
    "Kodala",
    "Konarka",
    "Koraput",
    "Kuchaiburi",
    "Kuchinda",
    "Kumbhari",
    "Malakanagiri",
    "Nayagarh",
    "Nilgiri",
    "Nowrangapur",
    "Paradip Garh",
    "Patamundai",
    "Patnagarh",
    "Phulbani",
    "Polasara",
    "Puri",
    "Purushottampur",
    "Ramagiri Udayagiri",
    "Rambha",
    "Rampur",
    "Rasol",
    "Raurkela",
    "Rayagada",
    "Rengali",
    "Sambalpur",
    "Sonabedha",
    "Sonepur",
    "Sorada",
    "Sorala",
    "Soro",
    "Sundargarh",
    "Talcher",
    "Tarabha",
    "Titlagarh",
    "Tora",
    "Udala",
    "Udayagiri",
    "Umarkot"
  ],
  "Puducherry": [
    "Chempalli",
    "Mattul",
    "Puducherry",
    "Puthiyangadi"
  ],
  "Punjab": [
    "Ablu",
    "Abohar",
    "adampur",
    "Ajnala",
    "Akalgarh",
    "Alawalpur",
    "Algun",
    "Amritsar",
    "Anandpur",
    "Atari",
    "Awankh",
    "Baba Bakala",
    "Badru Khan",
    "Bagha Purana",
    "Bajwara",
    "Balaungi",
    "Banga",
    "Barnala",
    "Basi",
    "Bassian",
    "Batala",
    "Begowal",
    "Bhadaur",
    "Bhagsar",
    "Bhagta",
    "Bhai Rupa",
    "Bhambia Bhai",
    "Bhankarpur",
    "Bhatinda",
    "Bhawanigarh",
    "Bhikhi",
    "Bhikkiwind Uttar",
    "Bhogpur",
    "Bhucho Mandi",
    "Bilga",
    "Boha",
    "Budha Th_h",
    "Budhlada",
    "Bundala",
    "Bundala",
    "Buttar",
    "Buttar Khurd",
    "Chabal Kalan",
    "Chaoke",
    "Chhajli",
    "Chiman",
    "Chirak",
    "Chuhal",
    "Dala",
    "Dasuya",
    "Dera Baba Nanak",
    "Dhanaula",
    "Dhariwal",
    "Dharmkot",
    "Dhaula",
    "Dhilwan",
    "Dhilwan Kalan",
    "Dhuri",
    "Dinanagar",
    "Dirba",
    "Doda",
    "Faridkot",
    "Fateh Nangal",
    "Fatehabad",
    "Fatehgarh Churian",
    "Fazilka",
    "Ferozepore",
    "Ganga",
    "Garhshankar",
    "Ghagga",
    "Ghal Kalan",
    "Gharyala",
    "Gholia Kalan",
    "Giddarbaha",
    "Gidri",
    "Gil",
    "Gobindgarh",
    "Gobindpura",
    "Goraya",
    "Gurdaspur",
    "Guru Har Sahai",
    "Hadiaya",
    "Hajipur",
    "Halwara",
    "Hamira",
    "Hariana",
    "Harike",
    "Haripur",
    "Herseh Chhina",
    "Himmatpura",
    "Husainpur",
    "Jagraon",
    "Jaito",
    "Jalalabad",
    "Jalandhar",
    "Jalandhar Cantonment",
    "Jandiala",
    "Jugial",
    "Kadur Sahib",
    "Kalanaur",
    "Kaoni",
    "Kaonke",
    "Kapurthala",
    "Kartarpur",
    "Kathanian",
    "Khamanon Kalan",
    "Khanna",
    "Kharar",
    "Kharial",
    "Khem Karan",
    "Khizrpur",
    "Khokri Kalan",
    "Kishanpura Kalan",
    "Kot Bhai",
    "Kot Kapura",
    "Kot Shamir",
    "Kotha Guru",
    "Kotli Ablu",
    "Kulrian",
    "Ladhuka",
    "Lahra Muhabbat",
    "Lalru",
    "Laungowal",
    "Lopon",
    "Ludhiana",
    "Mahalpur",
    "Mahna",
    "Mahta",
    "Maihma Sarja",
    "Majitha",
    "Makhu",
    "Malaudh",
    "Malaut",
    "Maler Kotla",
    "Mallan",
    "Mamun",
    "Mandi Dabwali",
    "Manoke",
    "Mansa",
    "Mauli",
    "Maur",
    "Maur Kalan",
    "Miani",
    "Moga",
    "Morinda",
    "Mudki",
    "Mukerian",
    "Muktsar",
    "Mullanwala",
    "Nabha",
    "Nakodar",
    "Nangal Township",
    "Narot Mehra",
    "Nathana",
    "Nawashahr",
    "Nihal Singhwala",
    "Padiala",
    "Pakka Kalan",
    "Panjgirain Kalan",
    "Parol",
    "Pathankot",
    "Patiala",
    "Patti",
    "Phagwara",
    "Phillaur",
    "Qadian",
    "Rahon",
    "Raikot",
    "Rajpura",
    "Ralla",
    "Raman",
    "Raman Mandi",
    "Raonta",
    "Roda",
    "Ropar",
    "Rupana",
    "Sahna",
    "Saidoke",
    "Samadh Bhai",
    "Samalsar",
    "Samana",
    "Samrala",
    "Sanaur",
    "Sanghera",
    "Sangrur",
    "Sarai Jattan",
    "Sardulgarh",
    "Sathiala",
    "Shahkot",
    "Shatrana",
    "Sheron",
    "Sidhwan",
    "Singhanwala",
    "Sirhali Kalan",
    "Sobraon",
    "Sohana",
    "Sujanpur",
    "Sultanpur",
    "Sunam",
    "Sur Singh",
    "Talwandi Bhai",
    "Talwandi Chaudhrian",
    "Talwandi Sabo",
    "Talwara",
    "Tapa",
    "Tarn Taran",
    "Thandewala",
    "Tharial",
    "Tharike",
    "Thikriwala",
    "Tibba",
    "Tibbar",
    "Tibri",
    "Urpaar",
    "Valtoha",
    "Zerakpur",
    "Zira"
  ],
  "Rajasthan": [
    "Abu",
    "Ahor",
    "Ajmer",
    "Aklera",
    "Alwar",
    "Amarpura",
    "Arni ka Khera",
    "Asan",
    "Atru",
    "Badnor",
    "Bagor",
    "Bagra",
    "Bagrinagar",
    "Balia",
    "Bari",
    "Barod",
    "Beawar",
    "Behror",
    "Bhainsoda",
    "Bharatpur",
    "Bhasawar",
    "Bhilwara",
    "Bijaynagar",
    "Bikaner",
    "Bilara",
    "Bundi",
    "Chhoti Sadri",
    "Chittaurgarh",
    "Dadrewa",
    "Degana",
    "Deh",
    "Desuri",
    "Dhirwas",
    "Dhorimanna",
    "Dig",
    "Dungarpur",
    "Dungra Chhota",
    "Fatehpur",
    "Ganganagar",
    "Goluwali",
    "Goner",
    "Hanumangarh",
    "Harji",
    "Hindaun",
    "Hindoli",
    "Jaipur",
    "Jaisalmer",
    "Jaitpura",
    "Jalor",
    "Jasol",
    "Jayal",
    "Jodhpur",
    "Khairtal",
    "Khandela",
    "Khandhar",
    "Khejroli",
    "Kishangarh",
    "Kochhor",
    "Kota",
    "Lachhmangarh Sikar",
    "Lakheri",
    "Losal",
    "Makrana",
    "Malpura",
    "Mandalgarh",
    "Mandawa",
    "Mangrol",
    "Merta",
    "Nadbai",
    "Nadol",
    "Nagar",
    "Nana",
    "Nasirabad",
    "Nathdwara",
    "Nawai",
    "Nawalgarh",
    "Nayagaon",
    "Nim ka Thana",
    "Nimbahera",
    "Nohar",
    "Nokha",
    "Osian",
    "Pali",
    "Phalodi",
    "Phulera",
    "Pilani",
    "Pilibangan",
    "Pindwara",
    "Pokaran",
    "Pratapgarh",
    "Pushkar",
    "Raipur",
    "Raisinghnagar",
    "Rajaldesar",
    "Rajgarh",
    "Rajgarh",
    "Rajsamand",
    "Ramdeora",
    "Ramganj Mandi",
    "Ranigaon",
    "Raniwara Kalan",
    "Ratangarh",
    "Rawatbhata",
    "Rawatsar",
    "Reni",
    "Ringas",
    "Rohera",
    "Rupbas",
    "Sadri",
    "Sagwara",
    "Saila",
    "Salumbar",
    "Sambhar",
    "Sanchor",
    "Sandwa",
    "Sardarshahr",
    "Satyun",
    "Sawai Madhopur",
    "Semari",
    "Sewari",
    "Shahpura",
    "Shahpura",
    "Shiv",
    "Shivganj",
    "Shri Mahavirji",
    "Sikar",
    "Singhana",
    "Siriari",
    "Sirohi",
    "Siyana",
    "Sojat",
    "Sri Madhopur",
    "Sujangarh",
    "Suratgarh",
    "Suroth",
    "Takhatgarh",
    "Taranagar",
    "Toda Bhim",
    "Toda Rai Singh",
    "Tonk",
    "Uchen",
    "Udaipur",
    "Udaipur",
    "Warkan",
    "Zawal"
  ],
  "Sikkim": [
    "Gangtok",
    "Namchi"
  ],
  "Tamil Nadu": [
    "Abiramam",
    "Acharipallam",
    "Achchippatti",
    "Adamankottai",
    "Adigappadi",
    "Adigaratti",
    "Adiyakkamangalam",
    "Agaram",
    "Aivanallur",
    "Ajjanahalli",
    "Alagappapuram",
    "Alagarai",
    "Alamadi",
    "alampalaiyam",
    "Alanganallur",
    "Alangayam",
    "alangudi",
    "alangulam",
    "Aliyabad",
    "Allinagaram",
    "Alukkuli",
    "Alwa Tirunagari",
    "alwarkurichchi",
    "Ambalavayal",
    "Ambasamudram",
    "Ambattur",
    "Ambatturai",
    "Ammapettai",
    "Ammapettai",
    "Ammavarikuppam",
    "Ammur",
    "anaiyur",
    "Anakaputtur",
    "Anamalais",
    "Anandapuram",
    "Andanappettai",
    "andipalaiyam",
    "andippatti",
    "Andiyappanur",
    "Angalakurichchi",
    "Angichettippalaiyam",
    "Anj_halli",
    "anjukulippatti",
    "Annamalainagar",
    "Annur",
    "Anuppampattu",
    "appukkudal",
    "Arachchalur",
    "Arani",
    "Arantangi",
    "Arasur",
    "Aravakkurichchi",
    "Arcot",
    "Arimalam",
    "Ariyalur",
    "Arkonam",
    "Arni",
    "Arumbakkam",
    "Arumbavur",
    "arumuganeri",
    "Aruppukkottai",
    "Aruvikkara",
    "Attanur",
    "Attappampatti",
    "Attibele",
    "Attimarappatti",
    "Attippattu",
    "Attur",
    "atturkuppam",
    "avadattur",
    "avadi",
    "Aval_palli",
    "Avalpundurai",
    "Avalurpet",
    "Avanashipalaiyam",
    "Avaniyapuram",
    "ayikudi",
    "Ayodhyapattanam",
    "Ayyampalaiyam",
    "Ayyampettai",
    "B_rikai",
    "Bagalur",
    "Baisuhalli",
    "Balakrishnanpatti",
    "Balasamudram",
    "Bargur",
    "Bellatti",
    "Belur",
    "Bendrahalli",
    "Bhavani",
    "Bikkatti",
    "Bodinayakkanur",
    "Bodippatti",
    "Bommayapalaiyam",
    "Brahmadesam",
    "Brahmana Periya Agraharam",
    "Budalur",
    "Budamangalam",
    "Budipuram",
    "Chavuttahalli",
    "Chekkal",
    "Chembagaramanpudur",
    "Chengam",
    "Chennai",
    "Chennampatti",
    "Chennimalai",
    "Cheramkod",
    "Chettikulam",
    "Chettimangurichchi",
    "Chettinayakkanpatti",
    "Chettipalaiyam",
    "Chettipalaiyam",
    "Chettipulam",
    "Chettiyapatti",
    "Cheyyar",
    "Chidambaram",
    "Chikkarampalaiyam",
    "Chingleput",
    "Chinna Kalaiyamputtur",
    "Chinna Salem",
    "Chinnakkampalaiyam",
    "Chinnakkavundanur",
    "Chinnalapatti",
    "Chinnamanur",
    "Chinnampalaiyam",
    "Chinnasekkadu",
    "Chinnatadagam",
    "Chinnavadampatti",
    "Chintalavadi",
    "Chittandikavundanur",
    "Chittarkottal",
    "Chittayankottai",
    "Chittur",
    "Chokkalingapuram",
    "Chokkampatti",
    "Chokkanathapuram",
    "Cholavandan",
    "Cholavaram",
    "Coimbatore",
    "Conjeeveram",
    "Coonoor",
    "Cuddalore",
    "Dalavaypattanam",
    "Damal",
    "Darasuram",
    "Desavilakku",
    "Devadanappatti",
    "Devanakavundanur",
    "Devanangurichchi",
    "Devarshola",
    "Devikapuram",
    "Devipattinam",
    "Dharapuram",
    "Dharmapuram",
    "Dharmapuri",
    "Dindigul",
    "Doddappanayakkanur",
    "Dombachcheri",
    "Duraiswamipuram",
    "Eduttavaynattam",
    "Elambalur",
    "Elandakuttai",
    "Elattur",
    "Elavanasur",
    "Elumalai",
    "Elurpatti",
    "Ennamangalam",
    "Eral",
    "Eranapuram",
    "Eraniel",
    "Eriyodu",
    "Erode",
    "Errahalli",
    "Erumad",
    "Erumaippatti",
    "Erumaippatti",
    "Erumapalaiyam",
    "Erutukada",
    "Ervadi",
    "Esanai",
    "Ettaiyapuram",
    "Ettapur",
    "Ettimadai",
    "Ganapatipalaiyam",
    "Gangaikondan",
    "Gangavalli",
    "Ganguvarpatti",
    "Gingee",
    "Gopalasamudram",
    "Gopichettipalaiyam",
    "Gudalur",
    "Gudalur",
    "Gudalur",
    "Gudalur",
    "Gudiyattam",
    "Gullapuram",
    "Gummudipundi",
    "Gundur",
    "Hanumantanpatti",
    "Harur",
    "Hosur",
    "Hulikal",
    "Hullatti",
    "Idangansalai",
    "Idappadi",
    "Idumbavanam",
    "Ikkadu",
    "Ikkarai Boluvampatti",
    "Ilaiyankudi",
    "Ilampillai",
    "Iluppur",
    "Inungur",
    "Iraiyur",
    "Irugur",
    "Irungalur",
    "Jadayampalaiyam",
    "Jagannadapuram",
    "Jakkampalaiyam",
    "Jalakandapuram",
    "Jalarpet",
    "Jambai",
    "Jambukuttaippatti",
    "Jayamkondacholapuram",
    "Jettihalli",
    "Kachchippalli",
    "Kadachchinallur",
    "Kadaiyam",
    "Kadaiyanallur",
    "Kadaladi",
    "Kadamalaikkundu",
    "Kadanadu",
    "Kadanganeri",
    "Kadattur",
    "Kadiapattanam",
    "Kadiyampatti",
    "Kaguchi",
    "Kaikkudi",
    "Kakalur",
    "Kalaiyamputtur",
    "Kalakkadu",
    "Kalappalangulam",
    "Kalappatti",
    "Kalavai",
    "Kalingiyam",
    "Kalladai",
    "Kallakkudi",
    "Kallakkurichchi",
    "Kallanai",
    "Kallidaikurichi",
    "Kallupatti",
    "Kalugumalai",
    "Kalvarpatti",
    "Kamalapuram",
    "Kamayakkavundanpatti",
    "Kambainellur",
    "Kambaliyampatti",
    "Kambam",
    "Kambaneri Pudukkudi",
    "Kambur",
    "Kamudi",
    "Kanavaypatti",
    "Kanavaypudur",
    "Kandanur",
    "Kandiyankovil",
    "Kangayam",
    "Kaniyambadi",
    "Kaniyur",
    "Kanjikkovil",
    "Kannamanayakkanur",
    "Kannamangalam",
    "Kannampalaiyam",
    "Kannandahalli",
    "Kannanendal",
    "Kannankurichchi",
    "Kannivadi",
    "Kanniyakumari",
    "Kannudaiyampatti",
    "Kanyakulam",
    "Kappiyara",
    "Karadichittur",
    "Karai",
    "Karaikkudi",
    "Karaiyampudur",
    "Karamadai",
    "Karambakkudi",
    "Karattuppalaiyam",
    "Karivalamvandanallur",
    "Kariyapatti",
    "Karkudalpatti",
    "Karukkalvadi",
    "Karumandi Chellipalaiyam",
    "Karumattampatti",
    "Karuppur",
    "Karuppur",
    "Karur",
    "Karuvelampatti",
    "Karuveppampatti",
    "Kasavanampatti",
    "Kasipalaiyam",
    "Katpadi",
    "Kattagaram",
    "Kattari",
    "Kattirippulam",
    "Kattivakkam",
    "Kattukkottai",
    "Kattupputtur",
    "Kaveripatnam",
    "Kavundappadi",
    "Kayalpattanam",
    "Kayattar",
    "Kelamangalam",
    "Kengarai",
    "Kesarimangalam",
    "Kesavapuram",
    "Ketti",
    "Khansahibpuram",
    "Kil Perambalur",
    "Kil Valur",
    "Kilakkarai",
    "Kilakkurichchi",
    "Kilankundal",
    "Kilkottai",
    "Kilkunda",
    "Killai",
    "Kilmangalam",
    "Kilminnal",
    "Kilrajakularaman",
    "Kilvisharam",
    "Kinattukkadavu",
    "Kiramangalam",
    "Kiranur",
    "Kirippatti",
    "Kittanapalli",
    "Kodaikanal",
    "Kodaimangalam",
    "Kodakkal",
    "Kodangipatti",
    "Kodikkulam",
    "Kodikkulam",
    "Kodikulam",
    "Kodivalasa",
    "Kodumudi",
    "Koduvilarpatti",
    "Kolachel",
    "Kolappalur",
    "Kollankulam",
    "Kombai",
    "Kombai",
    "Kondalampatti",
    "Kondarangi Kiranur",
    "Kondayampalaiyam",
    "Konganapuram",
    "Kongupatti",
    "Koranampatti",
    "Koshanam",
    "Kotagiri",
    "Kotharpettai",
    "Kottagudi Muttanad",
    "Kottaikuppam",
    "Kottaipatti",
    "Kottaiyur",
    "Kottampatti",
    "Kottaram",
    "Kottur",
    "Kovilpatti",
    "Kovilpatti",
    "Kovilur",
    "Krishnagiri",
    "Krishnarayapuram",
    "Kudangulam",
    "Kudavasal",
    "Kulasegaram",
    "Kulasekharapuram",
    "Kulattuppalaiyam",
    "Kulattur",
    "Kulittalai",
    "Kumaralingam",
    "Kumaramangalam",
    "Kumarapalaiyam",
    "Kumarapuram",
    "Kumaravadi",
    "Kumbakonam",
    "Kunimedu",
    "Kuniyamuttur",
    "Kunnattur",
    "Kunnur",
    "Kuppachchipalaiyam",
    "Kurichchi",
    "Kurichchi",
    "Kurichchi",
    "Kurivikod",
    "Kurumbalur",
    "Kurumbapalaiyam",
    "Kuttalam",
    "Kuttanallur",
    "Kuttappatti",
    "Kuttattuppatti",
    "Kuzhittura",
    "Labbaikkudikkadu",
    "Lakkampatti",
    "Lakshminarayanapuram",
    "Lakshmipuram",
    "Lalgudi",
    "Laligam",
    "Latteri",
    "Livinjipuram",
    "M_la Gudalur",
    "Madanancheri",
    "Madathapatti",
    "Madattukkulam",
    "Maddur",
    "Madepalli",
    "Madhavaram",
    "Madipakkam",
    "Madukkarai",
    "Madukkur",
    "Madurai",
    "Maduraivayal",
    "Magilampupuram",
    "Maharajapuram",
    "Malaimachchampatti",
    "Mallagunta",
    "Mallappadi",
    "Mallapuram",
    "Mallapuram",
    "Mallasamudram",
    "Mallikkundam",
    "Mamarappatti",
    "Manali",
    "Manalurpettai",
    "Manamadurai",
    "Manamelkudi",
    "Manamodu",
    "Manappakkam",
    "Manapparai",
    "Manavalakurichi",
    "Mandalavadi",
    "Mandapam",
    "Mangalam",
    "Mangalam",
    "Mangalam",
    "Mangalapuram",
    "Manivilundan",
    "Manjathala",
    "Mannachchanellur",
    "Mannadipattu",
    "Mannarai",
    "Mannargudi",
    "Mannargudi",
    "Maratturai",
    "Marudur",
    "Marudur",
    "Marungur",
    "Maruttuvakkudi",
    "Masakkavundanchettipalaiyam",
    "Masinigudi",
    "Mattigiri",
    "Mayamankurichchi",
    "Mayiladi",
    "Meddappakkam",
    "Mel Bhuvanagiri",
    "Mel Nariyappanur",
    "Mel Palaiyam",
    "Mel Seval",
    "Melmadai",
    "Melpanaikkadu",
    "Melur",
    "Merkanam",
    "Mettupalaiyam",
    "Mettuppalaiyam",
    "Mettuppalaiyam",
    "Mevani",
    "Midalam",
    "Milattur",
    "Minakshipuram",
    "Minakshipuram",
    "Minnal",
    "Minnampalli",
    "Mittahalli",
    "Modachchur",
    "Modakkurichchi",
    "Modavandisatyamangalam",
    "Mohanur",
    "Moparipalaiyam",
    "Morur",
    "Mudichchur",
    "Mudukulattur",
    "Mugalivakkam",
    "Mukasi Pidariyur",
    "Mukkudal",
    "Mukondapalli",
    "Mulaikkaraippatti",
    "Mulakumud",
    "Mulanur",
    "Murugampalaiyam",
    "Murungattoluvu",
    "Musiri",
    "Muthuswamipuram",
    "Muttalakanpatti",
    "Muttamtura",
    "Muttanampalaiyam",
    "Muttayyapuram",
    "Muttunayakkanpatti",
    "Muttupet",
    "Nachchandupatti",
    "Naduhatti",
    "Naduvattam",
    "Nagaiyampatti",
    "Nagercoil",
    "Nagojanahalli",
    "Nalambur",
    "Nalikkalpatti",
    "Nallippalaiyam",
    "Nallur",
    "Namagiripettai",
    "Namakkal",
    "Nambiyur",
    "Nambutalai",
    "Nandiyalam",
    "Nangavalli",
    "Nangavaram",
    "Nanguneri",
    "Nanjai Kilabadi",
    "Nanjanad",
    "Nanjikkottai",
    "Nanjundapuram",
    "Nanthankulam",
    "Naranammalpuram",
    "Naranapuram",
    "Naranattenvanpatti",
    "Narasingam",
    "Narasingapuram",
    "Narasingapuram",
    "Naravarikuppam",
    "Nasiyanur",
    "Nattakkadaiyur",
    "Nattam",
    "Nattappettai",
    "Nattarampalli",
    "Nattarasankottai",
    "Navani",
    "Navappatti",
    "Navinipatti",
    "Nayanakulam",
    "Nazareth",
    "Nedugula",
    "Negapatam",
    "Nelali",
    "Nelkattumseval",
    "Nellikkuppam",
    "Nelliyalam",
    "Nelmadur",
    "Nemili",
    "Nenmem",
    "Nerinjippettai",
    "Nerkunram",
    "Nerupperichchal",
    "Nettadahalli",
    "Nettappakkam",
    "Neykkarappatti",
    "Neykkarappatti",
    "Neyveli",
    "Nidamangalam",
    "Nilaiyur",
    "Nilakkottai",
    "Nilambur",
    "Nilavarappatti",
    "Nottampatti",
    "Odaipatti",
    "Odaiyakulam",
    "Odatturai",
    "Odayarpatti",
    "Odugattur",
    "Olagadam",
    "Olaippatti",
    "Olalapadi",
    "Omalur",
    "Ootacamund",
    "Oppatavadi",
    "Ottaikkalmantapam",
    "Ottakkadai",
    "Ottapparai",
    "Ottappidaram",
    "Oulgaret",
    "Pachchaimalaiyankottai",
    "Pachchampalaiyam",
    "Padaivedu",
    "Padav_du",
    "Padiyanallur",
    "Padiyur",
    "Padmanabhapuram",
    "Padugaipattu",
    "Paiganapalli",
    "Paittur",
    "Pakkam",
    "Palaiya ayakkudi",
    "Palaiyam",
    "Palaiyampatti",
    "Palakodu",
    "Palamedu",
    "Palangarai",
    "Palangavangudi",
    "Palanisettipatti",
    "Palankottai",
    "Palavur",
    "Palepalli",
    "Palladam",
    "Pallapatti",
    "Pallappalaiyam",
    "Pallappalaiyam",
    "Pallappatti",
    "Pallappatti",
    "Pallattur",
    "Pallavaram",
    "Pallijkarani",
    "Pallikondai",
    "Pallipalaiyam",
    "Pallippatti",
    "Palni",
    "Pamban",
    "Panakkudi",
    "Panamarattuppatti",
    "Panapakkam",
    "Pandalkudi",
    "Pangunattam",
    "Panjampatti",
    "Pannaikkadu",
    "Pannaipuram",
    "Pannimadai",
    "Panpuli",
    "Panruti",
    "Papanasam",
    "Papireddippatti",
    "Pappakudi",
    "Pappakurichchi",
    "Pappampatti",
    "Paradarami",
    "Paraippatti",
    "Paramagudi",
    "Paramanandal",
    "Paramankurichi",
    "Paramati",
    "Parapatti",
    "Paravai",
    "Paravakkottai",
    "Partibanur",
    "Parur",
    "Pasupatikovil",
    "Patchur",
    "Pattamadai",
    "Pattanam",
    "Pattanam",
    "Pattiswaram",
    "Pattukkottai",
    "Pavittiram",
    "Pedappai",
    "Pennadam",
    "Pennagaram",
    "Peraiyur",
    "Perambalur",
    "Peranampattu",
    "Peravurani",
    "Periya Pattanam",
    "Periya Semur",
    "Periya Soragai",
    "Periyakoduveri",
    "Periyakulam",
    "Periyamuttur",
    "Periyanayakkanpalaiyam",
    "Periyanegamam",
    "Periyap_du",
    "Periyapuliyur",
    "Perumbakkam",
    "Perumbalai",
    "Perumuchchi",
    "Perundurai",
    "Perungudi",
    "Perungulam",
    "Perunkalattu",
    "Perunkolattur",
    "Perur",
    "Pettaivayttalai",
    "Pettampalaiyam",
    "Pillaiyarkuppam",
    "Pillanallur",
    "Podaturpeta",
    "Pollachi",
    "Polur",
    "Pongalur",
    "Ponmana",
    "Ponnai",
    "Ponnamaravati",
    "Ponnampatti",
    "Ponnampatti",
    "Ponneri",
    "Ponneri",
    "Poonamallee",
    "Porur",
    "Pottanur",
    "Pottipuram",
    "Pottireddippatti",
    "Prataparampuram",
    "Pudukkottai",
    "Pudukkottai",
    "Pudupattanam",
    "Puduppattanam",
    "Puduppatti",
    "Puduppatti",
    "Pudur",
    "Pudur",
    "Puduvayal",
    "Pukkulam",
    "Pulicat",
    "Puligunta",
    "Pulivalam",
    "Puliyampatti",
    "Puliyankudi",
    "Puliyara",
    "Puliyur",
    "Pullambadi",
    "Pullanvidudi",
    "Puluvappatti",
    "Pumalakkundu",
    "Pungulam",
    "Punjai Kalamangalam",
    "Punjai Lakkapuram",
    "Punjai Puliyampatti",
    "Punjai Turaiyampalaiyam",
    "Punnaikkayal",
    "Punnappatti",
    "Pushpattur",
    "Puttai",
    "Puttalam",
    "Puttanattam",
    "Puvalur",
    "Rajapalaiyam",
    "Ramanathapuram",
    "Ramanayakkanpalaiyam",
    "Ramapattanam",
    "Ramayipatti",
    "Rameswaram",
    "Ranipet",
    "Ranranagudipeta",
    "Rasingapuram",
    "Rasipuram",
    "Rasivarai Tottam",
    "Rayappanpatti",
    "Reddippatti",
    "Reddiyapatti",
    "Rettanai",
    "Rishivandiyam",
    "Saidapet",
    "Sakkamapatti",
    "Salamedu",
    "Salangaippalaiyam",
    "Salem",
    "Sallimedu",
    "Samalapuram",
    "Samayanallur",
    "Samsikapuram",
    "Sankaranayinar Kovil",
    "Sankaridrug",
    "Sarakkayhalli",
    "Satyamangalam",
    "Sayalkudi",
    "Sayarpuram",
    "Segarai",
    "Sembedu",
    "Semmarikulan",
    "Senapparetti",
    "Sendamangalam",
    "Sendamangalam",
    "Sendamaram",
    "Sendarappatti",
    "Sendurai",
    "Sendurai",
    "Sengurichchi",
    "Sermadevi",
    "Settiyarpatti",
    "Seven Pagodas",
    "Sevilimedu",
    "Sevur",
    "Seydunganallur",
    "Shanmukhasundarapuram",
    "Shencottah",
    "Shiyali",
    "Sholinghur",
    "Silaiyampatti",
    "Silamalai",
    "Silappadi",
    "Silvarpatti",
    "Silvarpatti",
    "Sindalakkundu",
    "Singalandapuram",
    "Singampunari",
    "Singapperumalkovil",
    "Sipalakottai",
    "Sirpanandal",
    "Sirugamani",
    "Sirugudi",
    "Sirumugai",
    "Siruvachchur",
    "Siruvalur",
    "Sivaganga",
    "Sivagiri",
    "Sivagiri",
    "Sivakasi",
    "Sivalarkulam",
    "Sivamalai",
    "Sivandipuram",
    "Solapuram",
    "Somarasampettai",
    "Somavarappatti",
    "Sottaiyampalaiyam",
    "Srimushnam",
    "Sriperumbudur",
    "Srirampuram",
    "Srivaikuntam",
    "Srivilliputtur",
    "Srvanampatti",
    "Suchindram",
    "Sukkampatti",
    "Sulagiri",
    "Suleswaranpatti",
    "Sundapalaiyam",
    "Sundarapandiyam",
    "Sundekuppam",
    "Surampatti",
    "Surandai",
    "Surappalli",
    "Suttamalli",
    "Swamimalai",
    "T_kkampatti",
    "Tadangam",
    "Tadapurambakkam",
    "Tadikombu",
    "Taiyur",
    "Takkali",
    "Takkolam",
    "Talainayar Agraharam",
    "Talaivasal",
    "Talakulam",
    "Talavadi",
    "Talugai",
    "Tamaraikkulam",
    "Tamarakulam",
    "Tamarankottai",
    "Tambaram",
    "Tammampatti",
    "Tanakkangulam",
    "Tandarampattu",
    "Tanichchiyam",
    "Tanippadi",
    "Tanjore",
    "Taramangalam",
    "Tazhakudi",
    "Tekkattur",
    "Tellar",
    "Tenambakkam",
    "Tengampudur",
    "Tenkasi",
    "Tenmalai",
    "Tepperumalnallur",
    "Terku Narippaiyur",
    "Terku Valliyur",
    "Terkuvenganallur",
    "Tettuppatti",
    "Tevaram",
    "Thevur",
    "Thimiri",
    "Tillaivilagam",
    "Timmarasanayakkanur",
    "Tindivanam",
    "Tinnanur",
    "Tinnevelly",
    "Tirubhuvane",
    "Tiruchchuli",
    "Tiruchendur",
    "Tiruchengodu",
    "Tirukkalikkunram",
    "Tirukkattuppalli",
    "Tirukkoyilur",
    "Tirumalaippatti",
    "Tirumalaiyampalaiyam",
    "Tirumangalam",
    "Tirumayam",
    "Tirumuruganpundi",
    "Tirunageswaram",
    "Tiruppachur",
    "Tiruppalai",
    "Tiruppalaikudi",
    "Tiruppanandal",
    "Tirupparangunram",
    "Tiruppattur",
    "Tiruppattur",
    "Tirupporur",
    "Tiruppur",
    "Tiruppuvanam",
    "Tiruttangal",
    "Tiruttani",
    "Tirutturaippundi",
    "Tiruvadanai",
    "Tiruvadi",
    "Tiruvaduturai",
    "Tiruvalam",
    "Tiruvalanjuli",
    "Tiruvallur",
    "Tiruvalur",
    "Tiruvambalapuram",
    "Tiruvankod",
    "Tiruvannamalai",
    "Tiruvasaladi",
    "Tiruvattar",
    "Tiruvengadam",
    "Tiruvennanallur",
    "Tiruverumbur",
    "Tiruvottiyur",
    "Tittachcheri",
    "Tittagudi",
    "Togamalai",
    "Tokkavadi",
    "Toluprpatti",
    "Tondi",
    "Tottiyam",
    "Tovala",
    "Tranquebar",
    "Trichinopoly",
    "Tudiyalur",
    "Tullukuttinayakkanur",
    "Tumberi",
    "Tumbippadi",
    "Tummanatti",
    "Tungavi",
    "Turaiyur",
    "Tuticorin",
    "Tuvagudi",
    "Tyagadurgam",
    "Udamalpet",
    "Udayendram",
    "Ulipuram",
    "Ullur",
    "Uppidamangalam",
    "Uppukkottai",
    "Uranganpatti",
    "Usilampatti",
    "Usuppur",
    "Uttamapalaiyam",
    "Uttaramerur",
    "uttukkuli",
    "V_ttakkaranpudur",
    "Vadacheri",
    "Vadakadu",
    "Vadakarai Kil Pidagai",
    "Vadakkanandal",
    "Vadakku Ariyanayakipuram",
    "Vadakku Valliyur",
    "Vadakku Viravanallur",
    "Vadamadurai",
    "Vadamugam Vellodu",
    "Vadapalanji",
    "Vadasikarambattu",
    "Vadasseri",
    "Vadavalam",
    "Vadavalli",
    "Vadippatti",
    "Vadugapatti",
    "Vadugappatti",
    "Vaikuntam",
    "Vairampatti",
    "Vairichettipalaiyam",
    "Valaiyampattu",
    "Valangiman",
    "Valantaravai",
    "Valattur",
    "Valavanur",
    "Vallam",
    "Vallapuram",
    "Vallur",
    "Valparai",
    "Vanavasi",
    "Vandalur",
    "Vandiyur",
    "Vanduvancheri",
    "Vaniyambadi",
    "Vannikkonendal",
    "Vannivedu",
    "Varadarajampettai",
    "Varatanapalli",
    "Vargaur",
    "Vasudevanallur",
    "Vattalkundu",
    "Vedappatti",
    "Vedaranniyam",
    "Vedasandur",
    "Vegarai",
    "Velakalnattam",
    "Velakkuttai",
    "Velampalaiyam",
    "Velampatti",
    "Velanganni",
    "Velappadi",
    "Vellakkinar",
    "Vellakkovil",
    "Vellalapuram",
    "Vellalur",
    "Vellar",
    "Vellarivalli",
    "Vellavadanparappu",
    "Vellipalaiyam",
    "Vellodu",
    "Vellore",
    "Velur",
    "Vembaditalam",
    "Vembarpatti",
    "Vembur",
    "Vengattur",
    "Vengavasal",
    "Vengikkal",
    "Vennandur",
    "Veppattur",
    "Verukulambu",
    "Vettaikkaraniruppu",
    "Vettavalam",
    "Vijayapati",
    "Vikramasingapuram",
    "Vikravandi",
    "Vilachcheri",
    "Vilandai",
    "Vilangudi",
    "Vilangurichchi",
    "Vilattikulam",
    "Vilavur",
    "Villupuram",
    "Vilpatti",
    "Viraganur",
    "Virakeralam",
    "Viralimalai",
    "Viralippatti",
    "Virapandi",
    "Virapandi",
    "Virapandi",
    "Virapandiyanpattanam",
    "Virappanchathiram",
    "Virapperumanallur",
    "Virudunagar",
    "Viswanathaperi",
    "Vitthalapuram",
    "Vriddhachalam",
    "Vubatalai",
    "Walajabad",
    "Walajapet",
    "Wandiwash",
    "Watrap",
    "Wellington",
    "Yedappalli",
    "Yercaud"
  ],
  "Telangana": [
    "Adilabad",
    "Advi Devalpalli",
    "alampur",
    "Alipur",
    "Allahdurg",
    "Alwal",
    "amangal",
    "Amarchinta",
    "Aminpur",
    "Amrabad",
    "Annaram",
    "Aravelli",
    "Armur",
    "Arrapalli",
    "arutla",
    "Asafabad",
    "Ashwaraopeta",
    "Aswapuram",
    "Atmakur",
    "Atmakur",
    "Ayyagarpet",
    "Bachchannapet",
    "Badepalli",
    "Badurpalle",
    "Baladharmaram",
    "Balkonda",
    "Bandlaguda",
    "Banswada",
    "Bardipuram",
    "Bayaram",
    "Belampalli",
    "Bhadrachalam",
    "Bhainsa",
    "Bhatpalli",
    "Bhongir",
    "Bibipet",
    "Bichkunda",
    "Biknur",
    "Bimgal",
    "Bodhan",
    "Bodupal",
    "Bomareddipalli",
    "Borgampad",
    "Chada",
    "Chandur",
    "Charakunda",
    "Chautapal",
    "Chegur",
    "Chegurumomadi",
    "Cherial",
    "Chevella",
    "Chilkuru",
    "Chilpur",
    "Chinna Mupparam",
    "Chintalapalli",
    "Chityal",
    "Chopadandi",
    "Damarcherla",
    "Damargidda",
    "Dammapeta",
    "Dandu Mailaram",
    "Dasnapur",
    "Devapur",
    "Devarkonda",
    "Dhanwada",
    "Dharmapuri",
    "Dharmaram",
    "Dharmaram",
    "Dharmasagaram",
    "Dhobipet",
    "Dilawarpur",
    "Domkonda",
    "Dornakal",
    "Dubak",
    "Dundigal",
    "Durpalli",
    "Farrukhnagar",
    "Gadda Madiral",
    "Gadwal",
    "Gajwel",
    "Ganaram",
    "Gandhari",
    "Gangadhar",
    "Garsekurti",
    "Gauravaram",
    "Ghambiraopet",
    "Ghanpur",
    "Ghatkesar",
    "Ghattupal",
    "Gokinepalle",
    "Golet",
    "Gondalga",
    "Gudur",
    "Gundi",
    "Gundumal",
    "Hasanparti",
    "Honwada",
    "Honwada",
    "Husnabad",
    "Huzurabad",
    "Huzurnagar",
    "Hyderabad",
    "Ibrahimpatan",
    "Ichora",
    "Indalvai",
    "Indurti",
    "Indurti",
    "Ingurti",
    "Inole",
    "Ippagudem",
    "Isnapuram",
    "Jadcherla",
    "Jaffar Khanpet",
    "Jagoniguda",
    "Jajireddigudem",
    "Jamikunta",
    "Jangamguda",
    "Jangaon",
    "Jangid",
    "Jankampet",
    "Jogipet",
    "Kallur",
    "Kalwakurti",
    "Kamalapuram",
    "Kamalapuram",
    "Kamareddipet",
    "Kanchanpalli",
    "Kannal",
    "Kapra",
    "Karankot",
    "Karimnagar",
    "Kartal",
    "Kesamudram",
    "Khajamahalpur",
    "Khammam",
    "Khanapur",
    "Khanapur",
    "Kisara",
    "Kodad",
    "Kodmial",
    "Koheda",
    "Kohir",
    "Kolanpak",
    "Kolnur",
    "Kompalle",
    "Kondaparti",
    "Korangal",
    "Koratla",
    "Kosgi",
    "Kotgir",
    "Kothapet",
    "Kottagudem",
    "Kukatpalli",
    "Kushmanchi",
    "Lakhsetipet",
    "Lingal",
    "Lingampalli",
    "Lingampet",
    "Maddur",
    "Madira",
    "Madnur",
    "Mahadeopur",
    "Mahbubabad",
    "Mahbubnagar",
    "Maisaram",
    "Makhtal",
    "Malial",
    "Malkajgiri",
    "Malkanur",
    "Mallampalli",
    "Mallaram",
    "Mamidipalli",
    "Mamidipalli",
    "Mamnur",
    "Manakondur",
    "Mancheral",
    "Mandamari",
    "Mangapet",
    "Mangur",
    "Mankal",
    "Mannegudam",
    "Manthani",
    "Marikal",
    "Maripad",
    "Marpalli",
    "Marreddipalli",
    "Mavinpalli",
    "Medak",
    "Medchal",
    "Medikunda",
    "Mellacheruvu",
    "Metpalli",
    "Mirdoddi",
    "Mirialguda",
    "Mirpeta",
    "Miryal",
    "Momanpet",
    "Mortad",
    "Mosrah",
    "Motkur",
    "Mudhol",
    "Mugdampalli",
    "Muhammadabad",
    "Mulug",
    "Munagala",
    "Mungod",
    "Mustafabad",
    "Nadugadda",
    "Nagawaram",
    "Nakrekal",
    "Nalgonda",
    "Nallikodur",
    "Nandigaon",
    "Nandipeta",
    "Narapalli",
    "Narayankher",
    "Narayanpet",
    "Narayanraopet",
    "Narkatpalli",
    "Narsampet",
    "Narsapur",
    "Narsimlapet",
    "Narsingi",
    "Narsingi",
    "Naspur",
    "Navipet",
    "Nellipaka",
    "Nellutla",
    "Netapur Tanda",
    "Nimmekal",
    "Nirmal",
    "Nizamabad",
    "Padakanti",
    "Paidiipalli",
    "Paloncha",
    "Pardiguda",
    "Pargi",
    "Parkal",
    "Parvatgiri",
    "Pata Uppal",
    "Patancheruvu",
    "Pebberu",
    "Pedda Adsarlapalli",
    "Pedda Mupparam",
    "Pedda Pendyala",
    "Peddapalli",
    "Peddapuram",
    "Penaballi",
    "Perket",
    "Peruvancha",
    "Pitlam",
    "Pochampalli",
    "Pocharam",
    "Polas",
    "Pongode",
    "Potangal",
    "Puduru",
    "Pulur",
    "Ragampet",
    "Raikal",
    "Raiparthi",
    "Rajaram",
    "Rajendranagar",
    "Ramachandrapuran",
    "Ramannapeta",
    "Ramareddi",
    "Ramayampet",
    "Ramgundam",
    "Ranjal",
    "Ratnapuram",
    "Revur",
    "Rudrangi",
    "Rudrur",
    "Sadaseopet",
    "Sangareddi",
    "Sarangapuram",
    "Sarapaka",
    "Secunderabad",
    "Shahmirpet",
    "Shamsabad",
    "Shamunpet",
    "Shankarampet",
    "Shankarpalli",
    "Siddipet",
    "Sirikonda",
    "Sirpur",
    "Sirsilla",
    "Soanpeta",
    "Srirangapur",
    "Sultanabad",
    "Suriapet",
    "Talapalli",
    "Tandur",
    "Tarlapalli",
    "Telkapalli",
    "Thogapalle",
    "Timmapur",
    "Timmapuram",
    "Tirmaigiri",
    "Tirmalgiri",
    "Tummalacheruvu",
    "Tupran",
    "Turkaguda",
    "Upperu",
    "Utnur",
    "Vaddapalli",
    "Vaddepalli",
    "Valkurti",
    "Vardannapet",
    "Vardhamankota",
    "Velair",
    "Vemalwada",
    "Vempatti",
    "Vemulanarva",
    "Venkatapuram",
    "Venkatapuram",
    "Vijayapuri North",
    "Vikarabad",
    "Villasagar",
    "Wadlakonda",
    "Wanparti",
    "Warangal",
    "Wargal",
    "Warni",
    "Wepangandla",
    "Yedapalli",
    "Yeddumailaram",
    "Yeldurti",
    "Yellanda",
    "Yellandu",
    "Yellareddi",
    "Yellareddi",
    "Yelmalla",
    "Yelpur",
    "Yenmangandla",
    "Zafargarh",
    "Zahirabad"
  ],
  "Tripura": [
    "Agartala",
    "Amarpur",
    "Belonia",
    "Dharmaragar",
    "Kailashahar",
    "Khowai",
    "Udaipur"
  ],
  "Uttar Pradesh": [
    "Achhnera",
    "Adalhat",
    "agra",
    "Ajodhya",
    "Akbarpur",
    "Akola",
    "Aligarh",
    "Amarwa Khurd",
    "Amroha",
    "Amsin",
    "Anandnagar",
    "Anupshahr",
    "Asara",
    "Atarra",
    "Bachhraon",
    "Baghpat",
    "Bahraigh",
    "Bairia",
    "Ballia",
    "Balrampur",
    "Balwa",
    "Baqiabad",
    "Bareilly",
    "Barhan",
    "Barhni",
    "Barokhar",
    "Barwa Sagar",
    "Basni",
    "Bhadohi",
    "Bhagwanpur Khurd",
    "Bhander",
    "Bijnor",
    "Bindki",
    "Biswan",
    "Budaun",
    "Budwan",
    "Bulandshahr",
    "Campiernagar",
    "Charkhari",
    "Charthawal",
    "Chauhanpatti",
    "Chaukhata",
    "Chunar",
    "Daryabad",
    "Debiapur",
    "Dharampur",
    "Dildarnagar",
    "Dilra",
    "Etah",
    "Etawah",
    "Faridpur",
    "Farrukhabad",
    "Fatehpur",
    "Fatehpur Sikri",
    "Fyzabad",
    "Gahmar",
    "Garhi",
    "Gawan",
    "Gharbara",
    "Ghaziabad",
    "Ghazipur",
    "Gondauli",
    "Gorakhpur",
    "Gursarai",
    "Hamirpur",
    "Hapur",
    "Harchandpur",
    "Hardoi",
    "Harpalpur",
    "Harra",
    "Hasanganj",
    "Hasanpur",
    "Hastinapur",
    "Jai",
    "Jalalabad",
    "Jauli",
    "Jaunpur",
    "Jhansi",
    "Kairana",
    "Kakrala",
    "Kalianpur",
    "Kalpi",
    "Kamalganj",
    "Kandrawan",
    "Kanpur",
    "Khairabad",
    "Khandauli",
    "Khandrauli",
    "Khanpur",
    "Khanpur",
    "Khiria Jhansi",
    "Khorabar",
    "Kulpahar",
    "Kurwar",
    "Laharpur",
    "Lakhna",
    "Lalganj",
    "Lalitpur",
    "Lohara",
    "Loni",
    "Lucknow",
    "Machchand",
    "Madhupur",
    "Maghar",
    "Mahmudabad",
    "Mainpuri",
    "Marahra",
    "Mathura",
    "Mau",
    "Mauranwan",
    "Meerut",
    "Mehnajpur",
    "Mihona",
    "Mirzapur",
    "Moradabad",
    "Muhammadabad",
    "Murtazabad",
    "Muzaffarnagar",
    "Nagina",
    "Nagra",
    "Najibabad",
    "Nakur",
    "Nanpara",
    "Naraura",
    "Naugaon Sadat",
    "Nautanwa",
    "Nawabganj",
    "Nihtaur",
    "Noida",
    "Nurpur",
    "Obra",
    "Orai",
    "Padrauna",
    "Paina",
    "Palia Kalan",
    "Parasi",
    "Patiali",
    "Pawayan",
    "Phulpur",
    "Pihani",
    "Pilibhit",
    "Pilkhua",
    "Pirbahora",
    "Prayagraj",
    "Pukhrayan",
    "Puranpur",
    "Purwa",
    "Purwa Utar",
    "Rae Bareli",
    "Raiganj Bazar",
    "Rajapur",
    "Raksaha",
    "Ramnagar",
    "Rampur",
    "Rankhandi",
    "Rasra",
    "Rath",
    "Renukut",
    "Reoti",
    "Robertsganj",
    "Rudarpur",
    "Rudauli",
    "Sadabad",
    "Safipur",
    "Saharanpur",
    "Sahaspur",
    "Sahaswan",
    "Sahawar",
    "Sahjanwa",
    "Saidpur",
    "Salimpur",
    "Sambalhera",
    "Sambhal",
    "Samdhin",
    "Samesi",
    "Samthar",
    "Sandi",
    "Sandila",
    "Sarauli",
    "Sardhana",
    "Sarsai Nawar",
    "Sarsawa",
    "Seohara",
    "Shafinagar",
    "Shahganj",
    "Shahjanpur",
    "Shamli",
    "Shamsabad",
    "Shamsabad",
    "Shekhupur",
    "Sheopuria",
    "Sherkot",
    "Sherpur Khurd",
    "Shikarpur",
    "Shikohabad",
    "Shishgarh",
    "Sidhauli",
    "Sihali Jagir",
    "Sikandarabad",
    "Sikandarpur",
    "Sikandra Rao",
    "Sirsaganj",
    "Sirsi",
    "Sitapur",
    "Siyana",
    "Sohwal",
    "Sohwal",
    "Sonbarsa",
    "Soron",
    "Suar",
    "Sultanpur",
    "Surir",
    "Talbahat",
    "Tandwa",
    "Thakraha",
    "Thana Bhawan",
    "Tilhar",
    "Tindwara",
    "Tirkha",
    "Tirwa",
    "Tulsipur",
    "Tundla",
    "Unao",
    "Unnao",
    "Usia",
    "Utehia",
    "Utraula",
    "Varanasi",
    "Vrindavan",
    "Zafarabad",
    "Zaidpur",
    "Zamania"
  ],
  "Uttarakhand": [
    "Almora",
    "Bageshwar",
    "Barkot",
    "Bhatpuri",
    "Dakpatthar",
    "Dehra Dun",
    "Dewal Thal",
    "Doiwala",
    "Gadarpur",
    "Haldwani",
    "Harbatpur",
    "Haridwar",
    "Jaspur",
    "Jhabrera",
    "Joshimath",
    "Kashipur",
    "Kela Khera",
    "Khatima",
    "Kichha",
    "Kotdwara",
    "Laksar",
    "Landhaura",
    "Mahuakheraganj",
    "Manglaur",
    "Mussoorie",
    "Nagla",
    "Naini Tal",
    "Pantnagar",
    "Paonta Sahib",
    "Pauri",
    "Pithoragarh",
    "Premnagar",
    "Ramnagar",
    "Rishikesh",
    "Rudarpur",
    "Rudraprayag",
    "Salempur",
    "Saundhonwali",
    "Sitarganj",
    "Srinagar",
    "Sultanpur",
    "Tanakpur",
    "Tehri",
    "Uttarkashi",
    "Vikasnagar"
  ],
  "West Bengal": [
    "adra",
    "Ahmadpur",
    "Alipur Duar",
    "Ambhua",
    "Amgachia",
    "amta",
    "Amtala",
    "Andal",
    "Antardipa",
    "Arambagh",
    "Aroali",
    "asansol",
    "Ayas",
    "Badantola",
    "Badkulla",
    "Baduria",
    "Bagnan",
    "Bagula",
    "Bahagalpur",
    "Baharampur",
    "Baharu",
    "Bahutal",
    "Baikunthapur",
    "Baj Baj",
    "Balarampur",
    "Balarampur",
    "Bali",
    "Balupur",
    "Balurghat",
    "Bangaon",
    "Bankra",
    "Bankura",
    "Bansbaria",
    "Banta",
    "Bara",
    "Bara Belun",
    "Barakpur",
    "Barasat",
    "Barddhaman",
    "Barjora",
    "Barnia",
    "Baruipur",
    "Barwan",
    "Basirhat",
    "Basudebpur",
    "Bauria",
    "Bawali",
    "Baynala",
    "Begampur",
    "Begampur",
    "Belakoba",
    "Beldanga",
    "Belpukur",
    "Berubari",
    "Bhabanipur",
    "Bhadreswar",
    "Bhagabanpur",
    "Bhagirathpur",
    "Bhagwangola",
    "Bhangar",
    "Bhanukumari",
    "Bhatpara",
    "Binnaguri",
    "Bishnupur",
    "Bolpur",
    "Chaital",
    "Chakapara",
    "Chakdaha",
    "Chaltabaria",
    "Champadanga",
    "Champahati",
    "Champdani",
    "Chandankiari",
    "Chandannagar",
    "Chandi",
    "Chandpur",
    "Chandrakona",
    "Chapra",
    "Charabidya",
    "Chawalhati",
    "Chilakhana",
    "Chittaranjan",
    "Chota Mollakhali",
    "Chunakhali",
    "Chunchura",
    "Contai",
    "Cossimbazar",
    "Daita",
    "Dalkola",
    "Dam Dam",
    "Damdama",
    "Darjeeling",
    "Dattapara",
    "Dattapulia",
    "Daulatnagar",
    "Daulatpur",
    "Debagram",
    "Dhamua",
    "Dhantola",
    "Dharir",
    "Dhulian",
    "Dhupgari",
    "Diamond Harbour",
    "Dighirpar",
    "Dinhata",
    "Dogachi",
    "Domahani",
    "Dora",
    "Dubrajpur",
    "Dumjor",
    "Durgapur",
    "Egra",
    "Fakirtaki",
    "Falakata",
    "Falimari",
    "Farakka",
    "Fatehpur",
    "Galsi",
    "Ganga Sagar",
    "Gangajalghati",
    "Gangarampur",
    "Garaimari",
    "Garulia",
    "Ghatal",
    "Ghoradal",
    "Gilarchat",
    "Giria",
    "Gobardanga",
    "Gok",
    "Gokarna",
    "Gopalnagar",
    "Gopalnagar",
    "Guskhara",
    "Habra",
    "Haldia",
    "Haldibari",
    "Halisahar",
    "Haora",
    "Hariharpara",
    "Harua",
    "Hugli",
    "Iarpur",
    "Ingraj Bazar",
    "Islampur",
    "Islampur",
    "Jagdispur",
    "Jalpaiguri",
    "Janai",
    "Janapul",
    "Jangipur",
    "Jaynagar-Majilpur",
    "Jaypul",
    "Jhalida",
    "Jhargram",
    "Jiaganj",
    "Jujharpur",
    "Kachhari",
    "Kaimati",
    "Kakdwip",
    "Kalaikunda",
    "Kalchini",
    "Kaliganj",
    "Kalimpong",
    "Kalinagar",
    "Kalinagar",
    "Kaliyaganj",
    "Kalna",
    "Kalyani",
    "Kamargani",
    "Kamarhati",
    "Kanakpur",
    "Kanchrapara",
    "Kandi",
    "Kankandighi",
    "Kankuria",
    "Karimpur",
    "Karsiyang",
    "Katigang",
    "Katoya",
    "Kesabpur",
    "Ketugram",
    "Kharagpur",
    "Kharar",
    "Khardah",
    "Khargram",
    "Khasbalanda",
    "Khirpai",
    "Kishanganj",
    "Koch Bihar",
    "Kola",
    "Kolkata",
    "Kotra",
    "Krishnanagar",
    "Krishnapur",
    "Kuli",
    "Kumarkhali",
    "Kumirimora",
    "Lakhipur",
    "Lalgola",
    "Madanpur",
    "Madari Hat",
    "Madhyamgram",
    "Mahadebnagar",
    "Mahadipur",
    "Mahalandi",
    "Mahespur",
    "Mahiari",
    "Mainaguri",
    "Makaya",
    "Malancha",
    "Maldah",
    "Malior",
    "Malipakar",
    "Manbazar",
    "Mangalkot",
    "Mankur",
    "Mansong",
    "Manteswar",
    "Margram",
    "Matabhanga",
    "Mayahaura",
    "Mayureswar",
    "Medinipur",
    "Memari",
    "Metekora",
    "Mirik",
    "Mitrapur",
    "Multi",
    "Muragacha",
    "Murshidabad",
    "Muthabana",
    "Nagar",
    "Nagtala",
    "Nahazari",
    "Naihati",
    "Nalgora",
    "Nalhati",
    "Nalua",
    "Natshal",
    "Navadwip",
    "Nazira",
    "Nibria",
    "Nij Khari",
    "Nijgaon Paranpur",
    "Odlabari",
    "Paiker",
    "Paikpara",
    "Palashi",
    "Panchanandapur",
    "Panchgram",
    "Panchla",
    "Pandua",
    "Panihati",
    "Panjipara",
    "Panskura",
    "Para",
    "Patiram",
    "Patrasaer",
    "Petua",
    "Phagu",
    "Pujali",
    "Puruliya",
    "Raghudebbati",
    "Raghunathpur",
    "Raiganj",
    "Rajbalhai",
    "Rajmahal",
    "Rajnagar",
    "Ramchandrapur",
    "Ramchandrapur",
    "Ramjibanpur",
    "Ramkali",
    "Ramnagar",
    "Rampur",
    "Rampur Hat",
    "Ranaghat",
    "Rangamati",
    "Rishra",
    "Rudra Nagar",
    "Sabang",
    "Sahapur",
    "Sainthia",
    "Saktipur",
    "Salar",
    "Salt Lake City",
    "Salua",
    "Samalpur",
    "Sanatikri",
    "Sankrail",
    "Saranga",
    "Satgachia",
    "Senda",
    "Shantipur",
    "Shiliguri",
    "Shrirampur",
    "Shyamnagar",
    "Singhbari",
    "Singur",
    "Sitalkuchi",
    "Siuri",
    "Sonada",
    "Sonakhal",
    "Sonamukhi",
    "Srikhanda",
    "Srikrishnapur",
    "Suknadanga",
    "Taki",
    "Talsur",
    "Tamluk",
    "Tarakeswar",
    "Tehata",
    "Tekpanja",
    "Tiorpara",
    "Titagarh",
    "Tufanganj",
    "Tulin",
    "Uluberiya",
    "Umrapur",
    "Uttarpara"
  ]
}